import { jsx as m, jsxs as P, Fragment as Jt } from "react/jsx-runtime";
import { useState as ee, useCallback as O, useRef as R, createContext as it, useContext as at, useLayoutEffect as en, useEffect as B, useMemo as Qe } from "react";
import { create as Nn, useStore as Bn } from "zustand";
import { createPortal as Vn } from "react-dom";
const tn = ["shift", "alt", "meta", "mod", "ctrl", "control"], Kn = {
  esc: "escape",
  return: "enter",
  left: "arrowleft",
  right: "arrowright",
  up: "arrowup",
  down: "arrowdown",
  ShiftLeft: "shift",
  ShiftRight: "shift",
  AltLeft: "alt",
  AltRight: "alt",
  MetaLeft: "meta",
  MetaRight: "meta",
  OSLeft: "meta",
  OSRight: "meta",
  ControlLeft: "ctrl",
  ControlRight: "ctrl"
};
function Q(e) {
  return (Kn[e.trim()] || e.trim()).toLowerCase().replace(/key|digit|numpad/, "");
}
function nn(e) {
  return tn.includes(e);
}
function Ve(e, t = ",") {
  return e.toLowerCase().split(t);
}
function Ke(e, t = "+", n = ">", r = !1, a, i) {
  let s = [], d = !1;
  e = e.trim(), e.includes(n) ? (d = !0, s = e.toLocaleLowerCase().split(n).map((u) => Q(u))) : s = e.toLocaleLowerCase().split(t).map((u) => Q(u));
  const c = {
    alt: s.includes("alt"),
    ctrl: s.includes("ctrl") || s.includes("control"),
    shift: s.includes("shift"),
    meta: s.includes("meta"),
    mod: s.includes("mod"),
    useKey: r
  }, l = s.filter((u) => !tn.includes(u));
  return {
    ...c,
    keys: l,
    description: a,
    isSequence: d,
    hotkey: e,
    metadata: i
  };
}
typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.code !== void 0 && rn([Q(e.code)]);
}), document.addEventListener("keyup", (e) => {
  e.code !== void 0 && on([Q(e.code)]);
})), typeof window < "u" && (window.addEventListener("blur", () => {
  Y.clear();
}), window.addEventListener("contextmenu", () => {
  setTimeout(() => {
    Y.clear();
  }, 0);
}));
const Y = /* @__PURE__ */ new Set();
function ct(e) {
  return Array.isArray(e);
}
function $n(e, t = ",") {
  return (ct(e) ? e : e.split(t)).every((n) => Y.has(n.trim().toLowerCase()));
}
function rn(e) {
  const t = Array.isArray(e) ? e : [e];
  Y.has("meta") && Y.forEach((n) => {
    nn(n) || Y.delete(n.toLowerCase());
  }), t.forEach((n) => {
    Y.add(n.toLowerCase());
  });
}
function on(e) {
  const t = Array.isArray(e) ? e : [e];
  e === "meta" ? Y.clear() : t.forEach((n) => {
    Y.delete(n.toLowerCase());
  });
}
function Xn(e, t, n) {
  (typeof n == "function" && n(e, t) || n === !0) && e.preventDefault();
}
function Zn(e, t, n) {
  return typeof n == "function" ? n(e, t) : n === !0 || n === void 0;
}
const Un = [
  "input",
  "textarea",
  "select",
  "searchbox",
  "slider",
  "spinbutton",
  "menuitem",
  "menuitemcheckbox",
  "menuitemradio",
  "option",
  "radio",
  "textbox"
];
function Yn(e) {
  return an(e, Un);
}
function an(e, t = !1) {
  const { target: n, composed: r } = e;
  let a, i;
  return _n(n) && r ? (a = e.composedPath()[0] && e.composedPath()[0].tagName, i = e.composedPath()[0] && e.composedPath()[0].role) : (a = n && n.tagName, i = n && n.role), ct(t) ? !!(a && t && t.some((s) => s.toLowerCase() === a.toLowerCase() || s === i)) : !!(a && t && t);
}
function _n(e) {
  return !!e.tagName && !e.tagName.startsWith("-") && e.tagName.includes("-");
}
function Gn(e, t) {
  return e.length === 0 && t ? !1 : t ? e.some((n) => t.includes(n)) || e.includes("*") : !0;
}
const qn = (e, t, n = !1) => {
  const { alt: r, meta: a, mod: i, shift: s, ctrl: d, keys: c, useKey: l } = t, { code: u, key: o, ctrlKey: v, metaKey: g, shiftKey: f, altKey: p } = e, h = Q(u);
  if (l && (c == null ? void 0 : c.length) === 1 && c.includes(o.toLowerCase()))
    return !0;
  if (!(c != null && c.includes(h)) && !["ctrl", "control", "unknown", "meta", "alt", "shift", "os"].includes(h))
    return !1;
  if (!n) {
    if (r !== p && h !== "alt" || s !== f && h !== "shift")
      return !1;
    if (i) {
      if (!g && !v)
        return !1;
    } else if (a !== g && h !== "meta" && h !== "os" || d !== v && h !== "ctrl" && h !== "control")
      return !1;
  }
  return c && c.length === 1 && c.includes(h) ? !0 : c && c.length > 0 ? c.includes(h) ? $n(c) : !1 : !c || c.length === 0;
}, cn = it(void 0), Qn = () => at(cn);
function Jn({ addHotkey: e, removeHotkey: t, children: n }) {
  return /* @__PURE__ */ m(cn.Provider, { value: { addHotkey: e, removeHotkey: t }, children: n });
}
function st(e, t) {
  return e && t && typeof e == "object" && typeof t == "object" ? Object.keys(e).length === Object.keys(t).length && // @ts-expect-error TS7053
  Object.keys(e).reduce((n, r) => n && st(e[r], t[r]), !0) : e === t;
}
const sn = it({
  hotkeys: [],
  activeScopes: [],
  // This array has to be empty instead of containing '*' as default, to check if the provider is set or not
  toggleScope: () => {
  },
  enableScope: () => {
  },
  disableScope: () => {
  }
}), er = () => at(sn), tr = ({ initiallyActiveScopes: e = ["*"], children: t }) => {
  const [n, r] = ee(e), [a, i] = ee([]), s = O((o) => {
    r((v) => v.includes("*") ? [o] : Array.from(/* @__PURE__ */ new Set([...v, o])));
  }, []), d = O((o) => {
    r((v) => v.filter((g) => g !== o));
  }, []), c = O((o) => {
    r((v) => v.includes(o) ? v.filter((g) => g !== o) : v.includes("*") ? [o] : Array.from(/* @__PURE__ */ new Set([...v, o])));
  }, []), l = O((o) => {
    i((v) => [...v, o]);
  }, []), u = O((o) => {
    i((v) => v.filter((g) => !st(g, o)));
  }, []);
  return /* @__PURE__ */ m(
    sn.Provider,
    {
      value: { activeScopes: n, hotkeys: a, enableScope: s, disableScope: d, toggleScope: c },
      children: /* @__PURE__ */ m(Jn, { addHotkey: l, removeHotkey: u, children: t })
    }
  );
};
function nr(e) {
  const t = R(void 0);
  return st(t.current, e) || (t.current = e), t.current;
}
const vt = (e) => {
  e.stopPropagation(), e.preventDefault(), e.stopImmediatePropagation();
}, rr = typeof window < "u" ? en : B;
function U(e, t, n, r) {
  const a = R(null), i = R(!1), s = Array.isArray(n) ? Array.isArray(r) ? void 0 : r : n, d = ct(e) ? e.join(s == null ? void 0 : s.delimiter) : e, c = Array.isArray(n) ? n : Array.isArray(r) ? r : void 0, l = O(t, c ?? []), u = R(l);
  c ? u.current = l : u.current = t;
  const o = nr(s), { activeScopes: v } = er(), g = Qn();
  return rr(() => {
    if ((o == null ? void 0 : o.enabled) === !1 || !Gn(v, o == null ? void 0 : o.scopes))
      return;
    let f = [], p;
    const h = (b, w = !1) => {
      var S;
      if (!(Yn(b) && !an(b, o == null ? void 0 : o.enableOnFormTags))) {
        if (a.current !== null) {
          const T = a.current.getRootNode();
          if ((T instanceof Document || T instanceof ShadowRoot) && T.activeElement !== a.current && !a.current.contains(T.activeElement)) {
            vt(b);
            return;
          }
        }
        (S = b.target) != null && S.isContentEditable && !(o != null && o.enableOnContentEditable) || Ve(d, o == null ? void 0 : o.delimiter).forEach((T) => {
          var M, I, k, D;
          if (T.includes((o == null ? void 0 : o.splitKey) ?? "+") && T.includes((o == null ? void 0 : o.sequenceSplitKey) ?? ">")) {
            console.warn(
              `Hotkey ${T} contains both ${(o == null ? void 0 : o.splitKey) ?? "+"} and ${(o == null ? void 0 : o.sequenceSplitKey) ?? ">"} which is not supported.`
            );
            return;
          }
          const E = Ke(
            T,
            o == null ? void 0 : o.splitKey,
            o == null ? void 0 : o.sequenceSplitKey,
            o == null ? void 0 : o.useKey,
            o == null ? void 0 : o.description,
            o == null ? void 0 : o.metadata
          );
          if (E.isSequence) {
            p = setTimeout(() => {
              f = [];
            }, (o == null ? void 0 : o.sequenceTimeoutMs) ?? 1e3);
            const A = E.useKey ? b.key : Q(b.code);
            if (nn(A.toLowerCase()))
              return;
            f.push(A);
            const F = (M = E.keys) == null ? void 0 : M[f.length - 1];
            if (A !== F) {
              f = [], p && clearTimeout(p);
              return;
            }
            f.length === ((I = E.keys) == null ? void 0 : I.length) && (u.current(b, E), p && clearTimeout(p), f = []);
          } else if (qn(b, E, o == null ? void 0 : o.ignoreModifiers) || (k = E.keys) != null && k.includes("*")) {
            if ((D = o == null ? void 0 : o.ignoreEventWhen) != null && D.call(o, b) || w && i.current)
              return;
            if (Xn(b, E, o == null ? void 0 : o.preventDefault), !Zn(b, E, o == null ? void 0 : o.enabled)) {
              vt(b);
              return;
            }
            u.current(b, E), w || (i.current = !0);
          }
        });
      }
    }, y = (b) => {
      b.code !== void 0 && (rn(Q(b.code)), ((o == null ? void 0 : o.keydown) === void 0 && (o == null ? void 0 : o.keyup) !== !0 || o != null && o.keydown) && h(b));
    }, x = (b) => {
      b.code !== void 0 && (on(Q(b.code)), i.current = !1, o != null && o.keyup && h(b, !0));
    }, L = a.current || (s == null ? void 0 : s.document) || document;
    return L.addEventListener("keyup", x, s == null ? void 0 : s.eventListenerOptions), L.addEventListener("keydown", y, s == null ? void 0 : s.eventListenerOptions), g && Ve(d, o == null ? void 0 : o.delimiter).forEach((b) => {
      g.addHotkey(
        Ke(
          b,
          o == null ? void 0 : o.splitKey,
          o == null ? void 0 : o.sequenceSplitKey,
          o == null ? void 0 : o.useKey,
          o == null ? void 0 : o.description,
          o == null ? void 0 : o.metadata
        )
      );
    }), () => {
      L.removeEventListener("keyup", x, s == null ? void 0 : s.eventListenerOptions), L.removeEventListener("keydown", y, s == null ? void 0 : s.eventListenerOptions), g && Ve(d, o == null ? void 0 : o.delimiter).forEach((b) => {
        g.removeHotkey(
          Ke(
            b,
            o == null ? void 0 : o.splitKey,
            o == null ? void 0 : o.sequenceSplitKey,
            o == null ? void 0 : o.useKey,
            o == null ? void 0 : o.description,
            o == null ? void 0 : o.metadata
          )
        );
      }), f = [], p && clearTimeout(p);
    };
  }, [d, o, v]), a;
}
const ln = "WEAVE_TIMELINE_HOTKEYS_SCOPE", or = 16;
function le(e, t, n) {
  if (e <= t) return 0;
  const r = or / n;
  return e - t + r;
}
function ir(e, t, n) {
  return {
    start: e,
    end: Math.min(e + t, n)
  };
}
function ar(e, t, n) {
  return t + e / n;
}
const cr = 80;
function sr(e) {
  const t = 1 / e;
  return [
    [5 * t, t],
    // labels every 5 frames,  minor every 1 frame
    [10 * t, 5 * t],
    // labels every 10 frames, minor every 5 frames
    [1, 10 * t],
    // labels every 1s,        minor every 10 frames
    [5, 1],
    // labels every 5s,        minor every 1s
    [10, 5],
    // labels every 10s,       minor every 5s
    [30, 10],
    // labels every 30s,       minor every 10s
    [60, 30],
    // labels every 1min,      minor every 30s
    [300, 60],
    // labels every 5min,      minor every 1min
    [600, 300]
    // labels every 10min,     minor every 5min
  ];
}
function lr(e, t) {
  const n = sr(t);
  let r = n[n.length - 1];
  for (const d of n)
    if (d[0] * e >= cr) {
      r = d;
      break;
    }
  const [a, i] = r, s = i < 1;
  return { interval: i, majorInterval: a, showFrames: s };
}
function ur(e, t, n, r, a) {
  const i = [], s = Math.round(r * a), d = Math.ceil(e / n) * n;
  for (let c = d; c <= t; c += n) {
    const l = Math.round(c * a) / a, o = Math.round(l * a) % s === 0;
    i.push({
      time: l,
      isMajor: o,
      label: o ? dr(l, a) : void 0
    });
  }
  return i;
}
function dr(e, t) {
  const n = Math.round(e * t), r = Math.round(t), a = Math.floor(n / r), i = n - a * r, s = Math.floor(a / 3600), d = Math.floor(a % 3600 / 60), c = a % 60;
  if (i > 0) {
    const u = (o) => String(o).padStart(2, "0");
    return `${u(c)}:${u(i)}`;
  }
  let l = "";
  return s > 0 && (l += `${s}h`), (s > 0 || d > 0) && (l += `${d}m`), l += `${c}s`, l;
}
function un(e, t, n, r, a, i) {
  const s = e * t, d = a / s, c = (n - r) / (a / e), l = n - c * d, u = i / d, o = le(a, d, u), v = Math.max(0, Math.min(l, o));
  return { newZoom: s, newScroll: v };
}
const q = 30, fr = 240, yt = 16, lt = 36, Bi = 40, $e = 32, ve = 4, bt = 6, St = 0.16, dn = 8, fn = 250, mr = 28, wt = 20, mn = 92, pn = 8, xt = 1.5, pr = 0.01, gn = 20, ce = 1;
function Xe(e, t, n) {
  const r = e / t, a = r > 0 ? n / r : 0;
  return { visibleDuration: r, pps: a, maxScroll: le(e, r, a) };
}
function gr() {
  return Nn((e, t) => ({
    // Media metadata
    duration: 0,
    frameRate: 30,
    // Playback state
    currentTime: 0,
    isPlaying: !1,
    // Zoom/scroll state
    zoomLevel: 1,
    scrollPosition: 0,
    containerWidth: 0,
    // Tracks
    tracks: [],
    // Snap indicator
    snapIndicatorTime: null,
    // Drag guard
    draggingTrackId: null,
    // Actions
    setMetadata(n, r = 30) {
      e({
        duration: n,
        frameRate: r,
        currentTime: 0,
        isPlaying: !1,
        zoomLevel: 1,
        scrollPosition: 0
      });
    },
    setDuration(n) {
      const { zoomLevel: r, scrollPosition: a, containerWidth: i } = t(), { maxScroll: s } = Xe(n, r, i);
      e({
        duration: n,
        scrollPosition: Math.min(a, s)
      });
    },
    setCurrentTime(n) {
      const { duration: r, currentTime: a, isPlaying: i, zoomLevel: s, scrollPosition: d } = t(), c = Math.max(0, Math.min(n, r));
      if (a !== c) {
        if (i) {
          const l = r / s;
          if (c < d) {
            e({ currentTime: c, scrollPosition: c });
            return;
          } else if (c > d + l) {
            e({ currentTime: c, scrollPosition: c - l * 0.9 });
            return;
          }
        }
        e({ currentTime: c });
      }
    },
    setPlaying(n) {
      t().isPlaying !== n && e({ isPlaying: n });
    },
    setZoomLevel(n) {
      const { duration: r, frameRate: a, scrollPosition: i, containerWidth: s } = t(), d = r * a / gn, c = Math.max(ce, Math.min(n, d)), { maxScroll: l } = Xe(r, c, s);
      e({
        zoomLevel: c,
        scrollPosition: Math.min(i, l)
      });
    },
    setScrollPosition(n) {
      const { duration: r, zoomLevel: a, containerWidth: i } = t(), { maxScroll: s } = Xe(r, a, i);
      e({ scrollPosition: Math.max(0, Math.min(n, s)) });
    },
    setContainerWidth(n) {
      e({ containerWidth: n });
    },
    setTrackStartTime(n, r) {
      const a = t().tracks.map((i) => i.id === n ? { ...i, startTime: r } : i);
      e({ tracks: a });
    },
    setTrackTrim(n, r) {
      const a = t().tracks.map((i) => i.id === n ? { ...i, ...r } : i);
      e({ tracks: a });
    },
    setTracks(n) {
      const { draggingTrackId: r } = t();
      if (r != null) {
        const a = t().tracks.find((i) => i.id === r);
        a && (n = n.map(
          (i) => i.id === r ? {
            ...i,
            startTime: a.startTime,
            duration: a.duration,
            trimStart: a.trimStart,
            trimEnd: a.trimEnd
          } : i
        ));
      }
      e({ tracks: n });
    },
    setSnapIndicatorTime(n) {
      e({ snapIndicatorTime: n });
    },
    setDraggingTrackId(n) {
      e({ draggingTrackId: n });
    }
  }));
}
const xe = (e) => e.duration / e.zoomLevel, Z = (e) => {
  const t = e.duration / e.zoomLevel;
  return t > 0 ? e.containerWidth / t : 0;
}, hn = (e) => e.duration * e.frameRate / gn, vn = it(null);
function K() {
  const e = at(vn);
  if (!e)
    throw new Error("useTimelineContext must be used within a <TimelineProvider>");
  return e;
}
function C(e) {
  const { store: t } = K();
  return Bn(t, e);
}
function Vi({
  children: e,
  duration: t,
  frameRate: n = 30,
  currentTime: r,
  isPlaying: a,
  onSeek: i,
  onPlayingChange: s,
  tracks: d,
  selectedTrackId: c,
  onTrackLockToggle: l,
  onTrackMuteToggle: u,
  onTrackVisibilityToggle: o,
  onTrackStartTimeChange: v,
  onTrackTrimChange: g,
  onTrackSelect: f,
  onTrackReorder: p
}) {
  const h = Qe(() => gr(), []), y = R(!1);
  B(() => {
    if (!t || !Number.isFinite(t)) return;
    const S = h.getState();
    S.duration === t && S.frameRate === n || (y.current = !0, S.setMetadata(t, n), y.current = !1);
  }, [h, t, n]);
  const x = R(r), L = R(a);
  x.current = r, L.current = a, B(() => {
    let S;
    function T() {
      const E = x.current;
      if (E != null) {
        const { currentTime: I, duration: k } = h.getState(), D = Math.max(0, Math.min(E, k));
        I !== D && h.getState().setCurrentTime(E);
      }
      const M = L.current;
      M != null && h.getState().isPlaying !== M && (y.current = !0, h.getState().setPlaying(M), y.current = !1), S = requestAnimationFrame(T);
    }
    return S = requestAnimationFrame(T), () => cancelAnimationFrame(S);
  }, [h]), B(() => {
    let S = h.getState().isPlaying;
    return h.subscribe((T) => {
      T.isPlaying !== S && (S = T.isPlaying, y.current || s(T.isPlaying));
    });
  }, [h, s]), B(() => {
    d && h.getState().setTracks(d);
  }, [d, h]);
  const b = c ?? null, w = Qe(
    () => ({
      store: h,
      onSeek: i,
      onTrackLockToggle: l,
      onTrackMuteToggle: u,
      onTrackVisibilityToggle: o,
      onTrackStartTimeChange: v,
      onTrackTrimChange: g,
      onTrackSelect: f,
      onTrackReorder: p,
      selectedTrackId: b
    }),
    [
      h,
      i,
      l,
      u,
      o,
      v,
      g,
      f,
      p,
      b
    ]
  );
  return /* @__PURE__ */ m(tr, { initiallyActiveScopes: [ln], children: /* @__PURE__ */ m(vn.Provider, { value: w, children: e }) });
}
function hr({ togglePlay: e, stepFrame: t }) {
  const n = C((f) => f.isPlaying), r = C((f) => f.setPlaying), a = C((f) => f.setCurrentTime), i = C((f) => f.tracks.length > 0), { store: s, onSeek: d, selectedTrackId: c, onTrackStartTimeChange: l } = K(), u = O(() => {
    n && r(!1);
  }, [n, r]), o = O(() => {
    i && (u(), a(0), d(0));
  }, [u, a, i, d]), v = O(() => {
    if (!i) return;
    u();
    const { duration: f } = s.getState();
    a(f), d(f);
  }, [u, a, i, s, d]), g = { enableOnFormTags: !1, scopes: [ln] };
  U(
    "space",
    (f) => {
      f.preventDefault(), e();
    },
    g
  ), U(
    "meta+left, ctrl+left",
    (f) => {
      f.preventDefault(), t(-1);
    },
    g
  ), U(
    "meta+right, ctrl+right",
    (f) => {
      f.preventDefault(), t(1);
    },
    g
  ), U(
    "meta+shift+left, ctrl+shift+left",
    (f) => {
      f.preventDefault(), t(-10);
    },
    g
  ), U(
    "meta+shift+right, ctrl+shift+right",
    (f) => {
      f.preventDefault(), t(10);
    },
    g
  ), U(
    "meta+shift+alt+left, ctrl+shift+alt+left",
    (f) => {
      f.preventDefault(), o();
    },
    g
  ), U(
    "meta+shift+alt+right, ctrl+shift+alt+right",
    (f) => {
      f.preventDefault(), v();
    },
    g
  ), U(
    "BracketLeft",
    () => {
      if (c == null) return;
      const { currentTime: f } = s.getState();
      u(), l(c, f, !1);
    },
    g
  ), U(
    "BracketRight",
    () => {
      if (c == null) return;
      const { currentTime: f, tracks: p } = s.getState(), h = p.find((y) => y.id === c);
      h && (u(), l(c, f - h.duration, !1));
    },
    g
  );
}
const vr = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M5.27734 2.44019C5.45049 2.44385 5.62082 2.48223 5.77832 2.55151L5.93066 2.63062L5.93262 2.63159L19.4375 10.8914C19.6282 11.0068 19.7861 11.1699 19.8955 11.364C20.0049 11.5581 20.0624 11.777 20.0625 11.9998C20.0625 12.2226 20.0049 12.4423 19.8955 12.6365C19.7865 12.8298 19.629 12.9909 19.4395 13.1062L5.93262 21.3679L5.93066 21.3689C5.7334 21.4886 5.50804 21.5544 5.27734 21.5593C5.04685 21.5642 4.81917 21.5084 4.61719 21.3972C4.46562 21.3138 4.33197 21.2014 4.22461 21.0671L4.12598 20.9255C4.00679 20.728 3.94178 20.5019 3.9375 20.2712V3.72827L3.95215 3.5564C3.97784 3.38663 4.03674 3.22294 4.12598 3.07495C4.24522 2.8774 4.41505 2.71457 4.61719 2.60327C4.81921 2.49208 5.04679 2.43536 5.27734 2.44019Z",
      fill: "currentColor"
    }
  )
] }), yr = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m("g", { clipPath: "url(#clip0_822_591)", children: /* @__PURE__ */ m(
    "path",
    {
      d: "M9 3.96533C9.72479 3.96533 10.3124 4.55307 10.3125 5.27783V20.2778C10.3125 21.0027 9.72487 21.5903 9 21.5903H5.25C4.52513 21.5903 3.9375 21.0027 3.9375 20.2778V5.27783C3.93763 4.55307 4.52521 3.96533 5.25 3.96533H9ZM18.75 3.96533C19.4748 3.96533 20.0624 4.55307 20.0625 5.27783V20.2778C20.0625 21.0027 19.4749 21.5903 18.75 21.5903H15C14.2751 21.5903 13.6875 21.0027 13.6875 20.2778V5.27783C13.6876 4.55307 14.2752 3.96533 15 3.96533H18.75Z",
      fill: "currentColor"
    }
  ) }),
  /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", { id: "clip0_822_591", children: /* @__PURE__ */ m("rect", { width: "24", height: "24", fill: "white", transform: "translate(0 0.777832)" }) }) })
] }), Tt = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M6 6.02246V18.0225",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M9 6.75811V17.2862C9.00114 17.4188 9.0378 17.5486 9.10616 17.6622C9.17451 17.7758 9.27206 17.869 9.38865 17.9321C9.50524 17.9951 9.63661 18.0258 9.76909 18.0209C9.90156 18.016 10.0303 17.9756 10.1419 17.904L18.4097 12.64C18.5139 12.574 18.5997 12.4828 18.6591 12.3748C18.7186 12.2668 18.7497 12.1455 18.7497 12.0222C18.7497 11.8989 18.7186 11.7776 18.6591 11.6696C18.5997 11.5615 18.5139 11.4703 18.4097 11.4044L10.1419 6.1403C10.0303 6.06873 9.90156 6.02839 9.76909 6.02346C9.63661 6.01854 9.50524 6.04921 9.38865 6.11229C9.27206 6.17538 9.17451 6.26856 9.10616 6.38214C9.0378 6.49572 9.00114 6.62555 9 6.75811Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] });
function ie({ style: e, component: t, ...n }) {
  switch (t) {
    case "span":
      return /* @__PURE__ */ m("span", { style: { display: "flex", ...e }, ...n });
    case "button":
      return /* @__PURE__ */ m("button", { style: { display: "flex", ...e }, ...n });
    default:
      return /* @__PURE__ */ m("div", { style: { display: "flex", ...e }, ...n });
  }
}
function br({ style: e, ...t }) {
  return /* @__PURE__ */ m(ie, { style: { flexDirection: "column", ...e }, ...t });
}
function Sr({ style: e, ...t }) {
  return /* @__PURE__ */ m(ie, { style: { justifyContent: "center", ...e }, ...t });
}
function J({ style: e, ...t }) {
  return /* @__PURE__ */ m(ie, { style: { alignItems: "center", ...e }, ...t });
}
function ue({ style: e, ...t }) {
  return /* @__PURE__ */ m(Sr, { style: { alignItems: "center", ...e }, ...t });
}
const X = "var(--Black92)", wr = "var(--Black40_T)", de = "var(--White100)", be = "var(--White80_T)", Te = "var(--White64_T)", fe = "var(--White40_T)", xr = "var(--White16_T)", N = "var(--White08_T)", Tr = "var(--White04_T)", yn = "var(--Yellow100)", Lr = "var(--Yellow64)", Cr = "#F1A0FA", Er = "#EF9092", kr = "#4452F2";
function se({ children: e, onClick: t, size: n = 24, disabled: r, ariaLabel: a, stopPropagation: i }) {
  return /* @__PURE__ */ m(
    ue,
    {
      component: "button",
      className: "icon-btn",
      style: {
        width: n,
        height: n,
        color: r ? fe : be,
        borderRadius: 4
      },
      disabled: r,
      "aria-label": a,
      onClick: (c) => {
        i && c.stopPropagation(), t();
      },
      onMouseDown: (c) => {
        i && c.stopPropagation();
      },
      children: e
    }
  );
}
function Pr({ options: e, value: t, onChange: n, size: r = 24 }) {
  const [a, i] = ee(null);
  return /* @__PURE__ */ m(Jt, { children: e.map((s, d) => {
    const c = s.value === t, l = a === d;
    let u = "transparent", o = be;
    return c && l ? (u = Lr, o = X) : c ? (u = yn, o = X) : l && (u = N, o = de), /* @__PURE__ */ m(
      ue,
      {
        component: "button",
        style: {
          width: r,
          height: r,
          padding: 0,
          borderRadius: 4,
          background: u,
          color: o
        },
        "aria-label": s.ariaLabel,
        onClick: () => n(s.value),
        onMouseEnter: () => i(d),
        onMouseLeave: () => i(null),
        children: s.icon
      },
      d
    );
  }) });
}
const Mr = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M12.7459 12.7421L20.4662 10.5859C20.6175 10.5395 20.7503 10.4465 20.8455 10.3201C20.9407 10.1936 20.9935 10.0403 20.9963 9.8821C20.9992 9.72386 20.9518 9.56878 20.8612 9.43907C20.7705 9.30935 20.6411 9.21165 20.4915 9.15994L3.9915 3.03994C3.85914 2.99493 3.71682 2.9878 3.58063 3.01937C3.44443 3.05095 3.31977 3.11996 3.22072 3.21863C3.12166 3.31729 3.05216 3.44168 3.02005 3.57775C2.98794 3.71382 2.9945 3.85616 3.039 3.98869L9.159 20.4887C9.2107 20.6383 9.30841 20.7677 9.43812 20.8584C9.56783 20.949 9.72291 20.9964 9.88115 20.9935C10.0394 20.9907 10.1927 20.9379 10.3191 20.8427C10.4455 20.7475 10.5386 20.6147 10.5849 20.4634L12.7459 12.7421Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Dr = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M15.7501 7.125C15.7501 6.62772 15.9477 6.15081 16.2993 5.79917C16.6509 5.44754 17.1279 5.25 17.6251 5.25C18.1224 5.25 18.5993 5.44754 18.951 5.79917C19.3026 6.15081 19.5001 6.62772 19.5001 7.125V14.25C19.5001 15.2349 19.3061 16.2102 18.9292 17.1201C18.5523 18.0301 17.9999 18.8569 17.3034 19.5533C16.607 20.2497 15.7802 20.8022 14.8703 21.1791C13.9603 21.556 12.985 21.75 12.0001 21.75C7.85826 21.75 6.30482 19.755 3.25138 13.3125C3.00666 12.8821 2.94213 12.3723 3.07185 11.8945C3.20158 11.4167 3.51504 11.0096 3.94383 10.762C4.37262 10.5144 4.88193 10.4465 5.36061 10.5731C5.83928 10.6996 6.24848 11.0104 6.49888 11.4375L8.25013 14.25V5.625C8.25013 5.12772 8.44768 4.65081 8.79931 4.29917C9.15094 3.94754 9.62785 3.75 10.1251 3.75C10.6224 3.75 11.0993 3.94754 11.451 4.29917C11.8026 4.65081 12.0001 5.12772 12.0001 5.625",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M12 11.25V4.125C12 3.62772 12.1975 3.15081 12.5492 2.79917C12.9008 2.44754 13.3777 2.25 13.875 2.25C14.3723 2.25 14.8492 2.44754 15.2008 2.79917C15.5525 3.15081 15.75 3.62772 15.75 4.125V11.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Lt = () => /* @__PURE__ */ m("div", { style: { width: "1px", height: "24px", background: N } }), bn = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M7.5 15.75H3C2.80109 15.75 2.61032 15.671 2.46967 15.5303C2.32902 15.3897 2.25 15.1989 2.25 15V9C2.25 8.80109 2.32902 8.61032 2.46967 8.46967C2.61032 8.32902 2.80109 8.25 3 8.25H7.5L14.25 3V21L7.5 15.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m("path", { d: "M7.5 8.25V15.75", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M18 10.0171C18.4825 10.5649 18.7487 11.2699 18.7487 11.9999C18.7487 12.7299 18.4825 13.4349 18 13.9827",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M20.7815 7.5C21.8884 8.73755 22.5003 10.3397 22.5003 12C22.5003 13.6603 21.8884 15.2624 20.7815 16.5",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Or = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M22.1028 9.35278C22.3225 9.13311 22.678 9.13311 22.8977 9.35278C23.1171 9.57248 23.1173 9.92813 22.8977 10.1477L21.0452 12.0002L22.8977 13.8528L22.97 13.9407C23.114 14.159 23.0898 14.4556 22.8977 14.6477C22.7056 14.8398 22.409 14.864 22.1907 14.72L22.1028 14.6477L20.2502 12.7952L18.3977 14.6477C18.1781 14.8673 17.8225 14.8671 17.6028 14.6477C17.3831 14.428 17.3831 14.0725 17.6028 13.8528L19.4553 12.0002L17.6028 10.1477C17.3831 9.92804 17.3831 9.57245 17.6028 9.35278C17.8225 9.13311 18.178 9.13311 18.3977 9.35278L20.2502 11.2053L22.1028 9.35278Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M13.9043 2.55591C14.0739 2.42401 14.3041 2.40097 14.4971 2.49536C14.69 2.58978 14.8125 2.78547 14.8125 3.00024V21.0002C14.8124 21.215 14.69 21.4107 14.4971 21.5051C14.3041 21.5995 14.0739 21.5764 13.9043 21.4446L7.30664 16.3127H3C2.65194 16.3127 2.3184 16.1741 2.07227 15.928C1.82616 15.6819 1.68754 15.3483 1.6875 15.0002V9.00024C1.6875 8.65218 1.82617 8.31864 2.07227 8.07251C2.31841 7.82637 2.6519 7.68774 3 7.68774H7.30664L13.9043 2.55591ZM8.06152 8.52661V15.4729L13.6875 19.8489V4.15063L8.06152 8.52661ZM3 8.81274C2.95027 8.81274 2.90235 8.83227 2.86719 8.86743C2.83207 8.90259 2.8125 8.95055 2.8125 9.00024V15.0002L2.82715 15.0715C2.83648 15.0941 2.84957 15.1154 2.86719 15.1331C2.90234 15.1682 2.9503 15.1877 3 15.1877H6.93652V8.81274H3Z",
      fill: "currentColor"
    }
  )
] }), Sn = ({
  onToggle: e,
  muted: t,
  size: n = "large",
  disabled: r
}) => {
  const a = n === "medium" ? 20 : 24, i = n === "medium" ? 14 : 18;
  return /* @__PURE__ */ m(se, { size: a, disabled: r, onClick: e, stopPropagation: !0, children: t ? /* @__PURE__ */ m(Or, { width: i, height: i }) : /* @__PURE__ */ m(bn, { width: i, height: i }) });
}, Ar = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m("path", { d: "M9.75 4.5L6 8.25L2.25 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })
] });
function Ir({ text: e, children: t }) {
  return /* @__PURE__ */ m("span", { style: { fontSize: "0.875rem", fontWeight: 400 }, children: e ?? t });
}
function Rr({ text: e, children: t }) {
  return /* @__PURE__ */ m("span", { style: { fontSize: "0.75rem", fontWeight: 500 }, children: e ?? t });
}
function jr({ text: e, children: t }) {
  return /* @__PURE__ */ m("span", { style: { fontSize: "0.75rem", fontWeight: 400 }, children: e ?? t });
}
function Wr({ text: e, children: t }) {
  return /* @__PURE__ */ m("span", { style: { fontSize: "0.625rem", fontWeight: 400, fontFamily: "'DM Mono', monospace" }, children: e ?? t });
}
const Ct = 1.1;
function Hr({ label: e, shortcut: t, action: n, onClose: r }) {
  return /* @__PURE__ */ m("div", { style: { padding: "0 4px" }, children: /* @__PURE__ */ P(
    "button",
    {
      className: "canvas-zoom-menu-item",
      style: {
        border: "none",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding: "4px 8px",
        borderRadius: 4,
        cursor: "pointer",
        color: de,
        fontSize: "0.75rem"
      },
      onClick: () => {
        n(), r();
      },
      children: [
        /* @__PURE__ */ m("span", { children: e }),
        /* @__PURE__ */ m("span", { style: { color: Te }, children: `⌘ ${t}` })
      ]
    }
  ) });
}
function Fr({ canvasZoom: e, onCanvasZoomChanged: t, onZoomToFit: n }) {
  const [r, a] = ee(!1), i = R(null), s = R(null);
  B(() => {
    if (!r) return;
    const f = (h) => {
      var y, x;
      (y = s.current) != null && y.contains(h.target) || (x = i.current) != null && x.contains(h.target) || a(!1);
    }, p = (h) => {
      h.key === "Escape" && (h.stopPropagation(), a(!1));
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", p, !0), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", p, !0);
    };
  }, [r]);
  const d = O(() => t(e * Ct), [t, e]), c = O(() => t(e / Ct), [t, e]), l = O(() => t(1), [t]), u = O(() => a(!1), []), o = [
    { label: "Zoom in", shortcut: "+", action: d },
    { label: "Zoom out", shortcut: "−", action: c },
    { label: "Zoom to 100%", shortcut: "0", action: l },
    { label: "Zoom to fit", shortcut: "1", action: n }
  ], [v, g] = ee({ bottom: 0, right: 0 });
  return en(() => {
    if (!r || !i.current) return;
    const f = i.current.getBoundingClientRect();
    g({ bottom: window.innerHeight - f.top + 4, right: window.innerWidth - f.right });
  }, [r]), /* @__PURE__ */ P(Jt, { children: [
    /* @__PURE__ */ P(
      "button",
      {
        ref: i,
        style: {
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
          justifyContent: "space-between",
          padding: "4px 8px",
          borderRadius: 4,
          width: "78px",
          cursor: "pointer",
          color: de,
          background: r ? N : "transparent",
          marginLeft: 8
        },
        onClick: (f) => {
          f.stopPropagation(), a((p) => !p);
        },
        onMouseDown: (f) => f.stopPropagation(),
        children: [
          /* @__PURE__ */ m(Rr, { text: `${Math.max(1, Math.trunc(e * 100))}%` }),
          /* @__PURE__ */ m(Ar, { style: { transform: r ? "rotate(180deg)" : void 0 } })
        ]
      }
    ),
    r && Vn(
      /* @__PURE__ */ m(
        "div",
        {
          ref: s,
          style: {
            position: "fixed",
            bottom: v.bottom,
            right: v.right,
            width: 180,
            background: X,
            border: `1px solid ${Tr}`,
            borderRadius: 8,
            padding: "4px 0",
            zIndex: 1e4
          },
          children: o.map((f) => /* @__PURE__ */ m(Hr, { ...f, onClose: u }, f.label))
        }
      ),
      document.body
    )
  ] });
}
function Oe(e, t) {
  const n = Math.round(Math.max(0, e) * t), r = n % t, a = Math.floor(n / t), i = Math.floor(a / 60), s = a % 60;
  return { minutes: i, seconds: s, frames: r };
}
function Et(e, t) {
  const n = e.minutes * 60 + e.seconds + e.frames / t;
  return Math.round(n * t) / t;
}
function kt(e, t, n) {
  switch (e) {
    case "minutes":
      return Math.max(0, t);
    case "seconds":
      return Math.max(0, Math.min(59, t));
    case "frames":
      return Math.max(0, Math.min(n - 1, t));
  }
}
const Pt = ["minutes", "seconds", "frames"];
function zr(e) {
  return String(Math.floor(e)).padStart(2, "0");
}
function Nr() {
  const e = C((w) => w.currentTime), t = C((w) => w.frameRate), n = C((w) => w.duration), r = C((w) => w.setCurrentTime), a = C((w) => w.isPlaying), i = C((w) => w.setPlaying), { onSeek: s } = K(), [d, c] = ee(!1), [l, u] = ee(() => Oe(e, t)), o = R(null), v = R([null, null, null]), g = Oe(e, t), f = d ? l : g, p = O(() => {
    const w = Et(l, t), S = Math.max(0, Math.min(w, n));
    r(S), s(S), c(!1);
  }, [l, t, n, r, s]), h = O(() => {
    u(Oe(e, t)), c(!1);
  }, [e, t]), y = O(() => {
    d || (u(Oe(e, t)), c(!0), a && i(!1));
  }, [d, e, t, a, i]), x = O(
    (w) => {
      var T;
      const S = w.relatedTarget;
      (T = o.current) != null && T.contains(S) || d && p();
    },
    [d, p]
  ), L = O(
    (w, S) => {
      const T = parseInt(S, 10);
      if (isNaN(T)) return;
      const E = kt(w, T, t);
      u((M) => ({ ...M, [w]: E }));
    },
    [t]
  ), b = (w, S) => {
    var M, I;
    const T = Pt[w], E = S.currentTarget;
    switch (S.key) {
      case "ArrowUp":
      case "ArrowDown": {
        S.preventDefault();
        const k = S.key === "ArrowUp" ? 1 : -1, D = kt(T, l[T] + k, t), A = { ...l, [T]: D };
        u(A);
        const F = Et(A, t), z = Math.max(0, Math.min(F, n));
        r(z), s(z);
        break;
      }
      case "ArrowLeft": {
        E.selectionStart === 0 && E.selectionEnd === 0 && w > 0 && (S.preventDefault(), (M = v.current[w - 1]) == null || M.focus());
        break;
      }
      case "ArrowRight": {
        const k = E.value.length;
        E.selectionStart === k && E.selectionEnd === k && w < 2 && (S.preventDefault(), (I = v.current[w + 1]) == null || I.focus());
        break;
      }
      case "Enter":
        S.preventDefault(), p(), E.blur();
        break;
      case "Escape":
        S.preventDefault(), h(), E.blur();
        break;
    }
  };
  return B(() => {
    const w = v.current, S = (T) => T.target.select();
    return w.forEach((T) => T == null ? void 0 : T.addEventListener("focus", S)), () => w.forEach((T) => T == null ? void 0 : T.removeEventListener("focus", S));
  }, []), /* @__PURE__ */ m(
    "div",
    {
      className: "timecode-input",
      ref: o,
      onBlur: x,
      style: {
        display: "inline-flex",
        alignItems: "center",
        height: 24,
        fontSize: "0.75rem",
        border: `1px solid ${xr}`,
        borderRadius: 4,
        padding: "0 8px",
        boxSizing: "border-box",
        transition: "border-color 0.15s"
      },
      children: Pt.map((w, S) => /* @__PURE__ */ P(J, { children: [
        S > 0 && /* @__PURE__ */ m(
          "span",
          {
            style: { position: "relative", top: "-1px", color: Te, pointerEvents: "none", userSelect: "none" },
            children: ":"
          }
        ),
        /* @__PURE__ */ m(
          "input",
          {
            ref: (T) => {
              v.current[S] = T;
            },
            className: "timecode-segment",
            type: "text",
            inputMode: "numeric",
            value: zr(f[w]),
            onFocus: y,
            onChange: (T) => L(w, T.target.value),
            onKeyDown: (T) => b(S, T),
            "aria-label": w,
            style: {
              width: "2ch",
              background: "transparent",
              border: "none",
              outline: "none",
              color: Te,
              textAlign: "center",
              padding: "1px 0",
              borderRadius: 2,
              caretColor: "transparent",
              font: "inherit"
            }
          }
        )
      ] }, w))
    }
  );
}
function Ki({
  isMuted: e = !1,
  onToggleMute: t,
  canvasMode: n,
  onCanvasModeChange: r,
  canvasZoom: a,
  onCanvasZoomChanged: i,
  onZoomToFit: s
}) {
  const d = C((y) => y.isPlaying), c = C((y) => y.currentTime <= 0), l = C((y) => y.currentTime >= y.duration), u = C((y) => y.setPlaying), o = C((y) => y.setCurrentTime), v = C((y) => y.tracks.length > 0), { store: g, onSeek: f } = K(), p = O(() => {
    v && u(!d);
  }, [d, u, v]), h = O(
    (y) => {
      if (!v) return;
      d && u(!1);
      const { currentTime: x, duration: L, frameRate: b } = g.getState(), w = Math.round(x * b), T = Math.max(0, Math.min(w + y, Math.round(L * b))) / b;
      o(T), f(T);
    },
    [d, u, o, v, g, f]
  );
  return hr({ togglePlay: p, stepFrame: h }), /* @__PURE__ */ P(
    J,
    {
      className: "timeline-playback-controls",
      style: {
        height: "40px",
        padding: "0 8px",
        background: X,
        fontFamily: "'DM Sans', sans-serif"
      },
      children: [
        /* @__PURE__ */ m("div", { style: { flex: 1 } }),
        /* @__PURE__ */ P(ue, { style: { gap: 8 }, children: [
          /* @__PURE__ */ m(se, { onClick: () => h(-1), disabled: !v || c, ariaLabel: "Step back one frame", children: /* @__PURE__ */ m(Tt, { style: { transform: "scaleX(-1)" } }) }),
          /* @__PURE__ */ m(se, { onClick: p, disabled: !v, ariaLabel: d ? "Pause" : "Play", children: d ? /* @__PURE__ */ m(yr, { width: 20, height: 20 }) : /* @__PURE__ */ m(vr, { width: 20, height: 20 }) }),
          /* @__PURE__ */ m(se, { onClick: () => h(1), disabled: !v || l, ariaLabel: "Step forward one frame", children: /* @__PURE__ */ m(Tt, {}) }),
          /* @__PURE__ */ m(Nr, {}),
          /* @__PURE__ */ m(Lt, {}),
          t && /* @__PURE__ */ m(Sn, { onToggle: t, muted: e, disabled: !v })
        ] }),
        /* @__PURE__ */ P(J, { style: { flex: 1, justifyContent: "flex-end" }, children: [
          /* @__PURE__ */ m(J, { style: { gap: "4px", marginRight: "8px" }, children: /* @__PURE__ */ m(
            Pr,
            {
              options: [
                { value: "select", icon: /* @__PURE__ */ m(Mr, { width: 20, height: 20 }), ariaLabel: "Select tool" },
                { value: "pan", icon: /* @__PURE__ */ m(Dr, { width: 20, height: 20 }), ariaLabel: "Pan tool" }
              ],
              value: n,
              onChange: r,
              size: 24
            }
          ) }),
          /* @__PURE__ */ m(Lt, {}),
          /* @__PURE__ */ m(Fr, { canvasZoom: a, onCanvasZoomChanged: i, onZoomToFit: s })
        ] })
      ]
    }
  );
}
function Br(e) {
  if (Array.isArray(e)) return e;
}
function Vr(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, a, i, s, d = [], c = !0, l = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(c = (r = i.call(n)).done) && (d.push(r.value), d.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (l) throw a;
      }
    }
    return d;
  }
}
function Je(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function wn(e, t) {
  if (e) {
    if (typeof e == "string") return Je(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Je(e, t) : void 0;
  }
}
function Kr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xn(e, t) {
  return Br(e) || Vr(e, t) || wn(e, t) || Kr();
}
var Ze = {}, ye = {}, Mt;
function Tn() {
  if (Mt) return ye;
  Mt = 1, Object.defineProperty(ye, "__esModule", { value: !0 }), ye.bind = void 0;
  function e(t, n) {
    var r = n.type, a = n.listener, i = n.options;
    return t.addEventListener(r, a, i), function() {
      t.removeEventListener(r, a, i);
    };
  }
  return ye.bind = e, ye;
}
var oe = {}, Dt;
function $r() {
  if (Dt) return oe;
  Dt = 1;
  var e = oe && oe.__assign || function() {
    return e = Object.assign || function(i) {
      for (var s, d = 1, c = arguments.length; d < c; d++) {
        s = arguments[d];
        for (var l in s) Object.prototype.hasOwnProperty.call(s, l) && (i[l] = s[l]);
      }
      return i;
    }, e.apply(this, arguments);
  };
  Object.defineProperty(oe, "__esModule", { value: !0 }), oe.bindAll = void 0;
  var t = /* @__PURE__ */ Tn();
  function n(i) {
    if (!(typeof i > "u"))
      return typeof i == "boolean" ? {
        capture: i
      } : i;
  }
  function r(i, s) {
    if (s == null)
      return i;
    var d = e(e({}, i), { options: e(e({}, n(s)), n(i.options)) });
    return d;
  }
  function a(i, s, d) {
    var c = s.map(function(l) {
      var u = r(l, d);
      return (0, t.bind)(i, u);
    });
    return function() {
      c.forEach(function(u) {
        return u();
      });
    };
  }
  return oe.bindAll = a, oe;
}
var Ot;
function Xr() {
  return Ot || (Ot = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.bindAll = e.bind = void 0;
    var t = /* @__PURE__ */ Tn();
    Object.defineProperty(e, "bind", { enumerable: !0, get: function() {
      return t.bind;
    } });
    var n = /* @__PURE__ */ $r();
    Object.defineProperty(e, "bindAll", { enumerable: !0, get: function() {
      return n.bindAll;
    } });
  })(Ze)), Ze;
}
var me = /* @__PURE__ */ Xr(), Ln = "data-pdnd-honey-pot";
function Cn(e) {
  return e instanceof Element && e.hasAttribute(Ln);
}
function ut(e) {
  var t = document.elementsFromPoint(e.x, e.y), n = xn(t, 2), r = n[0], a = n[1];
  return r ? Cn(r) ? a ?? null : r : null;
}
function Le(e) {
  "@babel/helpers - typeof";
  return Le = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Le(e);
}
function Zr(e, t) {
  if (Le(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Le(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ur(e) {
  var t = Zr(e, "string");
  return Le(t) == "symbol" ? t : t + "";
}
function _(e, t, n) {
  return (t = Ur(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Yr = 2147483647;
function At(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function It(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? At(Object(n), !0).forEach(function(r) {
      _(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : At(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ce = 2, Rt = Ce / 2;
function _r(e) {
  return {
    x: Math.floor(e.x),
    y: Math.floor(e.y)
  };
}
function Gr(e) {
  return {
    x: e.x - Rt,
    y: e.y - Rt
  };
}
function qr(e) {
  return {
    x: Math.max(e.x, 0),
    y: Math.max(e.y, 0)
  };
}
function Qr(e) {
  return {
    x: Math.min(e.x, window.innerWidth - Ce),
    y: Math.min(e.y, window.innerHeight - Ce)
  };
}
function jt(e) {
  var t = e.client, n = Qr(qr(Gr(_r(t))));
  return DOMRect.fromRect({
    x: n.x,
    y: n.y,
    width: Ce,
    height: Ce
  });
}
function Wt(e) {
  var t = e.clientRect;
  return {
    left: "".concat(t.left, "px"),
    top: "".concat(t.top, "px"),
    width: "".concat(t.width, "px"),
    height: "".concat(t.height, "px")
  };
}
function Jr(e) {
  var t = e.client, n = e.clientRect;
  return (
    // is within horizontal bounds
    t.x >= n.x && t.x <= n.x + n.width && // is within vertical bounds
    t.y >= n.y && t.y <= n.y + n.height
  );
}
function eo(e) {
  var t = e.initial, n = document.createElement("div");
  n.setAttribute(Ln, "true");
  var r = jt({
    client: t
  });
  Object.assign(n.style, It(It({
    // Setting a background color explicitly to avoid any inherited styles.
    // Looks like this could be `opacity: 0`, but worried that _might_
    // cause the element to be ignored on some platforms.
    // When debugging, set backgroundColor to something like "red".
    backgroundColor: "transparent",
    position: "fixed",
    // Being explicit to avoid inheriting styles
    padding: 0,
    margin: 0,
    boxSizing: "border-box"
  }, Wt({
    clientRect: r
  })), {}, {
    // We want this element to absorb pointer events,
    // it's kind of the whole point 😉
    pointerEvents: "auto",
    // Want to make sure the honey pot is top of everything else.
    // Don't need to worry about native drag previews, as they will
    // have been rendered (and removed) before the honey pot is rendered
    zIndex: Yr
  })), document.body.appendChild(n);
  var a = me.bind(window, {
    type: "pointermove",
    listener: function(s) {
      var d = {
        x: s.clientX,
        y: s.clientY
      };
      r = jt({
        client: d
      }), Object.assign(n.style, Wt({
        clientRect: r
      }));
    },
    // using capture so we are less likely to be impacted by event stopping
    options: {
      capture: !0
    }
  });
  return function(s) {
    var d = s.current;
    if (a(), Jr({
      client: d,
      clientRect: r
    })) {
      n.remove();
      return;
    }
    function c() {
      l(), n.remove();
    }
    var l = me.bindAll(window, [
      {
        type: "pointerdown",
        listener: c
      },
      {
        type: "pointermove",
        listener: c
      },
      {
        type: "focusin",
        listener: c
      },
      {
        type: "focusout",
        listener: c
      },
      // a 'pointerdown' should happen before 'dragstart', but just being super safe
      {
        type: "dragstart",
        listener: c
      },
      // if the user has dragged something out of the window
      // and then is dragging something back into the window
      // the first events we will see are "dragenter" (and then "dragover").
      // So if we see any of these we need to clear the post drag fix.
      {
        type: "dragenter",
        listener: c
      },
      {
        type: "dragover",
        listener: c
      }
      // Not adding a "wheel" event listener, as "wheel" by itself does not
      // resolve the bug.
    ], {
      // Using `capture` so less likely to be impacted by other code stopping events
      capture: !0
    });
  };
}
function to() {
  var e = null;
  function t() {
    return e = null, me.bind(window, {
      type: "pointermove",
      listener: function(a) {
        e = {
          x: a.clientX,
          y: a.clientY
        };
      },
      // listening for pointer move in capture phase
      // so we are less likely to be impacted by events being stopped.
      options: {
        capture: !0
      }
    });
  }
  function n() {
    var r = null;
    return function(i) {
      var s = i.eventName, d = i.payload;
      if (s === "onDragStart") {
        var c = d.location.initial.input, l = e ?? {
          x: c.clientX,
          y: c.clientY
        };
        r = eo({
          initial: l
        });
      }
      if (s === "onDrop") {
        var u, o = d.location.current.input;
        (u = r) === null || u === void 0 || u({
          current: {
            x: o.clientX,
            y: o.clientY
          }
        }), r = null, e = null;
      }
    };
  }
  return {
    bindEvents: t,
    getOnPostDispatch: n
  };
}
function no(e) {
  if (Array.isArray(e)) return Je(e);
}
function ro(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function oo() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function En(e) {
  return no(e) || ro(e) || wn(e) || oo();
}
function te(e) {
  var t = null;
  return function() {
    if (!t) {
      for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
        a[i] = arguments[i];
      var s = e.apply(this, a);
      t = {
        result: s
      };
    }
    return t.result;
  };
}
var io = te(function() {
  return process.env.NODE_ENV === "test" ? !1 : navigator.userAgent.includes("Firefox");
}), dt = te(function() {
  if (process.env.NODE_ENV === "test")
    return !1;
  var t = navigator, n = t.userAgent;
  return n.includes("AppleWebKit") && !n.includes("Chrome");
}), et = {
  isLeavingWindow: Symbol("leaving"),
  isEnteringWindow: Symbol("entering")
};
function ao(e) {
  var t = e.dragLeave;
  return dt() ? t.hasOwnProperty(et.isLeavingWindow) : !1;
}
(function() {
  if (typeof window > "u" || process.env.NODE_ENV === "test" || !dt())
    return;
  function t() {
    return {
      enterCount: 0,
      isOverWindow: !1
    };
  }
  var n = t();
  function r() {
    n = t();
  }
  me.bindAll(
    window,
    [{
      type: "dragstart",
      listener: function() {
        n.enterCount = 0, n.isOverWindow = !0;
      }
    }, {
      type: "drop",
      listener: r
    }, {
      type: "dragend",
      listener: r
    }, {
      type: "dragenter",
      listener: function(i) {
        !n.isOverWindow && n.enterCount === 0 && (i[et.isEnteringWindow] = !0), n.isOverWindow = !0, n.enterCount++;
      }
    }, {
      type: "dragleave",
      listener: function(i) {
        n.enterCount--, n.isOverWindow && n.enterCount === 0 && (i[et.isLeavingWindow] = !0, n.isOverWindow = !1);
      }
    }],
    // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
      capture: !0
    }
  );
})();
function co(e) {
  return "nodeName" in e;
}
function so(e) {
  return co(e) && e.ownerDocument !== document;
}
function lo(e) {
  var t = e.dragLeave, n = t.type, r = t.relatedTarget;
  return n !== "dragleave" ? !1 : dt() ? ao({
    dragLeave: t
  }) : r == null ? !0 : io() ? so(r) : r instanceof HTMLIFrameElement;
}
function uo(e) {
  var t = e.onDragEnd;
  return [
    // ## Detecting drag ending for removed draggables
    //
    // If a draggable element is removed during a drag and the user drops:
    // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
    // 2. if not over a valid drop target (or cancelled): we get nothing
    // The "dragend" event will not fire on the source draggable if it has been
    // removed from the DOM.
    // So we need to figure out if a drag operation has finished by looking at other events
    // We can do this by looking at other events
    // ### First detection: "pointermove" events
    // 1. "pointermove" events cannot fire during a drag and drop operation
    // according to the spec. So if we get a "pointermove" it means that
    // the drag and drop operations has finished. So if we get a "pointermove"
    // we know that the drag is over
    // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
    // other pointer events. However, firefox will allow a few
    // pointer event to get through after a drag starts.
    // The most I've seen is 3
    {
      type: "pointermove",
      listener: /* @__PURE__ */ (function() {
        var n = 0;
        return function() {
          if (n < 20) {
            n++;
            return;
          }
          t();
        };
      })()
    },
    // ### Second detection: "pointerdown" events
    // If we receive this event then we know that a drag operation has finished
    // and potentially another one is about to start.
    // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
    {
      type: "pointerdown",
      listener: t
    }
  ];
}
function Se(e) {
  return {
    altKey: e.altKey,
    button: e.button,
    buttons: e.buttons,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    shiftKey: e.shiftKey,
    clientX: e.clientX,
    clientY: e.clientY,
    pageX: e.pageX,
    pageY: e.pageY
  };
}
var fo = function(t) {
  var n = [], r = null, a = function() {
    for (var s = arguments.length, d = new Array(s), c = 0; c < s; c++)
      d[c] = arguments[c];
    n = d, !r && (r = requestAnimationFrame(function() {
      r = null, t.apply(void 0, n);
    }));
  };
  return a.cancel = function() {
    r && (cancelAnimationFrame(r), r = null);
  }, a;
}, Ue = fo(function(e) {
  return e();
}), Ae = /* @__PURE__ */ (function() {
  var e = null;
  function t(r) {
    var a = requestAnimationFrame(function() {
      e = null, r();
    });
    e = {
      frameId: a,
      fn: r
    };
  }
  function n() {
    e && (cancelAnimationFrame(e.frameId), e.fn(), e = null);
  }
  return {
    schedule: t,
    flush: n
  };
})();
function mo(e) {
  var t = e.source, n = e.initial, r = e.dispatchEvent, a = {
    dropTargets: []
  };
  function i(d) {
    r(d), a = {
      dropTargets: d.payload.location.current.dropTargets
    };
  }
  var s = {
    start: function(c) {
      var l = c.nativeSetDragImage, u = {
        current: n,
        previous: a,
        initial: n
      };
      i({
        eventName: "onGenerateDragPreview",
        payload: {
          source: t,
          location: u,
          nativeSetDragImage: l
        }
      }), Ae.schedule(function() {
        i({
          eventName: "onDragStart",
          payload: {
            source: t,
            location: u
          }
        });
      });
    },
    dragUpdate: function(c) {
      var l = c.current;
      Ae.flush(), Ue.cancel(), i({
        eventName: "onDropTargetChange",
        payload: {
          source: t,
          location: {
            initial: n,
            previous: a,
            current: l
          }
        }
      });
    },
    drag: function(c) {
      var l = c.current;
      Ue(function() {
        Ae.flush();
        var u = {
          initial: n,
          previous: a,
          current: l
        };
        i({
          eventName: "onDrag",
          payload: {
            source: t,
            location: u
          }
        });
      });
    },
    drop: function(c) {
      var l = c.current, u = c.updatedSourcePayload;
      Ae.flush(), Ue.cancel(), i({
        eventName: "onDrop",
        payload: {
          source: u ?? t,
          location: {
            current: l,
            previous: a,
            initial: n
          }
        }
      });
    }
  };
  return s;
}
var tt = {
  isActive: !1
};
function kn() {
  return !tt.isActive;
}
function po(e) {
  return e.dataTransfer ? e.dataTransfer.setDragImage.bind(e.dataTransfer) : null;
}
function go(e) {
  var t = e.current, n = e.next;
  if (t.length !== n.length)
    return !0;
  for (var r = 0; r < t.length; r++)
    if (t[r].element !== n[r].element)
      return !0;
  return !1;
}
function ho(e) {
  var t = e.event, n = e.dragType, r = e.getDropTargetsOver, a = e.dispatchEvent;
  if (!kn())
    return;
  var i = vo({
    event: t,
    dragType: n,
    getDropTargetsOver: r
  });
  tt.isActive = !0;
  var s = {
    current: i
  };
  Ye({
    event: t,
    current: i.dropTargets
  });
  var d = mo({
    source: n.payload,
    dispatchEvent: a,
    initial: i
  });
  function c(g) {
    var f = go({
      current: s.current.dropTargets,
      next: g.dropTargets
    });
    s.current = g, f && d.dragUpdate({
      current: s.current
    });
  }
  function l(g) {
    var f = Se(g), p = Cn(g.target) ? ut({
      x: f.clientX,
      y: f.clientY
    }) : g.target, h = r({
      target: p,
      input: f,
      source: n.payload,
      current: s.current.dropTargets
    });
    h.length && (g.preventDefault(), Ye({
      event: g,
      current: h
    })), c({
      dropTargets: h,
      input: f
    });
  }
  function u() {
    s.current.dropTargets.length && c({
      dropTargets: [],
      input: s.current.input
    }), d.drop({
      current: s.current,
      updatedSourcePayload: null
    }), o();
  }
  function o() {
    tt.isActive = !1, v();
  }
  var v = me.bindAll(
    window,
    [{
      // 👋 Note: we are repurposing the `dragover` event as our `drag` event
      // this is because firefox does not publish pointer coordinates during
      // a `drag` event, but does for every other type of drag event
      // `dragover` fires on all elements that are being dragged over
      // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
      // 🦊😤
      type: "dragover",
      listener: function(f) {
        l(f), d.drag({
          current: s.current
        });
      }
    }, {
      type: "dragenter",
      listener: l
    }, {
      type: "dragleave",
      listener: function(f) {
        lo({
          dragLeave: f
        }) && (c({
          input: s.current.input,
          dropTargets: []
        }), n.startedFrom === "external" && u());
      }
    }, {
      // A "drop" can only happen if the browser allowed the drop
      type: "drop",
      listener: function(f) {
        if (s.current = {
          dropTargets: s.current.dropTargets,
          input: Se(f)
        }, !s.current.dropTargets.length) {
          u();
          return;
        }
        f.preventDefault(), Ye({
          event: f,
          current: s.current.dropTargets
        }), d.drop({
          current: s.current,
          // When dropping something native, we need to extract the latest
          // `.items` from the "drop" event as it is now accessible
          updatedSourcePayload: n.type === "external" ? n.getDropPayload(f) : null
        }), o();
      }
    }, {
      // "dragend" fires when on the drag source (eg a draggable element)
      // when the drag is finished.
      // "dragend" will fire after "drop" (if there was a successful drop)
      // "dragend" does not fire if the draggable source has been removed during the drag
      // or for external drag sources (eg files)
      // This "dragend" listener will not fire if there was a successful drop
      // as we will have already removed the event listener
      type: "dragend",
      listener: function(f) {
        s.current = {
          dropTargets: s.current.dropTargets,
          input: Se(f)
        }, u();
      }
    }].concat(En(uo({
      onDragEnd: u
    }))),
    // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
      capture: !0
    }
  );
  d.start({
    nativeSetDragImage: po(t)
  });
}
function Ye(e) {
  var t, n = e.event, r = e.current, a = (t = r[0]) === null || t === void 0 ? void 0 : t.dropEffect;
  a != null && n.dataTransfer && (n.dataTransfer.dropEffect = a);
}
function vo(e) {
  var t = e.event, n = e.dragType, r = e.getDropTargetsOver, a = Se(t);
  if (n.startedFrom === "external")
    return {
      input: a,
      dropTargets: []
    };
  var i = r({
    input: a,
    source: n.payload,
    target: t.target,
    current: []
  });
  return {
    input: a,
    dropTargets: i
  };
}
var Ht = {
  canStart: kn,
  start: ho
}, nt = /* @__PURE__ */ new Map();
function yo(e) {
  var t = e.typeKey, n = e.mount, r = nt.get(t);
  if (r)
    return r.usageCount++, r;
  var a = {
    typeKey: t,
    unmount: n(),
    usageCount: 1
  };
  return nt.set(t, a), a;
}
function bo(e) {
  var t = yo(e);
  return function() {
    t.usageCount--, !(t.usageCount > 0) && (t.unmount(), nt.delete(e.typeKey));
  };
}
function We() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function() {
    t.forEach(function(a) {
      return a();
    });
  };
}
function Pn(e, t) {
  var n = t.attribute, r = t.value;
  return e.setAttribute(n, r), function() {
    return e.removeAttribute(n);
  };
}
function Ft(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function G(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ft(Object(n), !0).forEach(function(r) {
      _(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ft(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _e(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = So(e)) || t) {
      n && (e = n);
      var r = 0, a = function() {
      };
      return { s: a, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(l) {
        throw l;
      }, f: a };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, s = !0, d = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var l = n.next();
    return s = l.done, l;
  }, e: function(l) {
    d = !0, i = l;
  }, f: function() {
    try {
      s || n.return == null || n.return();
    } finally {
      if (d) throw i;
    }
  } };
}
function So(e, t) {
  if (e) {
    if (typeof e == "string") return zt(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? zt(e, t) : void 0;
  }
}
function zt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Ge(e) {
  return e.slice(0).reverse();
}
function wo(e) {
  var t = e.typeKey, n = e.defaultDropEffect, r = /* @__PURE__ */ new WeakMap(), a = "data-drop-target-for-".concat(t), i = "[".concat(a, "]");
  function s(g) {
    return r.set(g.element, g), function() {
      return r.delete(g.element);
    };
  }
  function d(g) {
    if (process.env.NODE_ENV !== "production") {
      var f = r.get(g.element);
      f && console.warn("You have already registered a [".concat(t, "] dropTarget on the same element"), {
        existing: f,
        proposed: g
      }), g.element instanceof HTMLIFrameElement && console.warn(`
            We recommend not registering <iframe> elements as drop targets
            as it can result in some strange browser event ordering.
          `.replace(/\s{2,}/g, " ").trim());
    }
    var p = We(Pn(g.element, {
      attribute: a,
      value: "true"
    }), s(g));
    return te(p);
  }
  function c(g) {
    var f, p, h, y, x = g.source, L = g.target, b = g.input, w = g.result, S = w === void 0 ? [] : w;
    if (L == null)
      return S;
    if (!(L instanceof Element))
      return L instanceof Node ? c({
        source: x,
        target: L.parentElement,
        input: b,
        result: S
      }) : S;
    var T = L.closest(i);
    if (T == null)
      return S;
    var E = r.get(T);
    if (E == null)
      return S;
    var M = {
      input: b,
      source: x,
      element: E.element
    };
    if (E.canDrop && !E.canDrop(M))
      return c({
        source: x,
        target: E.element.parentElement,
        input: b,
        result: S
      });
    var I = (f = (p = E.getData) === null || p === void 0 ? void 0 : p.call(E, M)) !== null && f !== void 0 ? f : {}, k = (h = (y = E.getDropEffect) === null || y === void 0 ? void 0 : y.call(E, M)) !== null && h !== void 0 ? h : n, D = {
      data: I,
      element: E.element,
      dropEffect: k,
      // we are collecting _actual_ drop targets, so these are
      // being applied _not_ due to stickiness
      isActiveDueToStickiness: !1
    };
    return c({
      source: x,
      target: E.element.parentElement,
      input: b,
      // Using bubble ordering. Same ordering as `event.getPath()`
      result: [].concat(En(S), [D])
    });
  }
  function l(g) {
    var f = g.eventName, p = g.payload, h = _e(p.location.current.dropTargets), y;
    try {
      for (h.s(); !(y = h.n()).done; ) {
        var x, L = y.value, b = r.get(L.element), w = G(G({}, p), {}, {
          self: L
        });
        b == null || (x = b[f]) === null || x === void 0 || x.call(
          b,
          // I cannot seem to get the types right here.
          // TS doesn't seem to like that one event can need `nativeSetDragImage`
          // @ts-expect-error
          w
        );
      }
    } catch (S) {
      h.e(S);
    } finally {
      h.f();
    }
  }
  var u = {
    onGenerateDragPreview: l,
    onDrag: l,
    onDragStart: l,
    onDrop: l,
    onDropTargetChange: function(f) {
      var p = f.payload, h = new Set(p.location.current.dropTargets.map(function(V) {
        return V.element;
      })), y = /* @__PURE__ */ new Set(), x = _e(p.location.previous.dropTargets), L;
      try {
        for (x.s(); !(L = x.n()).done; ) {
          var b, w = L.value;
          y.add(w.element);
          var S = r.get(w.element), T = h.has(w.element), E = G(G({}, p), {}, {
            self: w
          });
          if (S == null || (b = S.onDropTargetChange) === null || b === void 0 || b.call(S, E), !T) {
            var M;
            S == null || (M = S.onDragLeave) === null || M === void 0 || M.call(S, E);
          }
        }
      } catch (V) {
        x.e(V);
      } finally {
        x.f();
      }
      var I = _e(p.location.current.dropTargets), k;
      try {
        for (I.s(); !(k = I.n()).done; ) {
          var D, A, F = k.value;
          if (!y.has(F.element)) {
            var z = G(G({}, p), {}, {
              self: F
            }), j = r.get(F.element);
            j == null || (D = j.onDropTargetChange) === null || D === void 0 || D.call(j, z), j == null || (A = j.onDragEnter) === null || A === void 0 || A.call(j, z);
          }
        }
      } catch (V) {
        I.e(V);
      } finally {
        I.f();
      }
    }
  };
  function o(g) {
    u[g.eventName](g);
  }
  function v(g) {
    var f = g.source, p = g.target, h = g.input, y = g.current, x = c({
      source: f,
      target: p,
      input: h
    });
    if (x.length >= y.length)
      return x;
    for (var L = Ge(y), b = Ge(x), w = [], S = 0; S < L.length; S++) {
      var T, E = L[S], M = b[S];
      if (M != null) {
        w.push(M);
        continue;
      }
      var I = w[S - 1], k = L[S - 1];
      if ((I == null ? void 0 : I.element) !== (k == null ? void 0 : k.element))
        break;
      var D = r.get(E.element);
      if (!D)
        break;
      var A = {
        input: h,
        source: f,
        element: D.element
      };
      if (D.canDrop && !D.canDrop(A) || !((T = D.getIsSticky) !== null && T !== void 0 && T.call(D, A)))
        break;
      w.push(G(G({}, E), {}, {
        // making it clear to consumers this drop target is active due to stickiness
        isActiveDueToStickiness: !0
      }));
    }
    return Ge(w);
  }
  return {
    dropTargetForConsumers: d,
    getIsOver: v,
    dispatchEvent: o
  };
}
function xo(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = To(e)) || t) {
      n && (e = n);
      var r = 0, a = function() {
      };
      return { s: a, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(l) {
        throw l;
      }, f: a };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, s = !0, d = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var l = n.next();
    return s = l.done, l;
  }, e: function(l) {
    d = !0, i = l;
  }, f: function() {
    try {
      s || n.return == null || n.return();
    } finally {
      if (d) throw i;
    }
  } };
}
function To(e, t) {
  if (e) {
    if (typeof e == "string") return Nt(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Nt(e, t) : void 0;
  }
}
function Nt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Bt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Lo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bt(Object(n), !0).forEach(function(r) {
      _(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Co() {
  var e = /* @__PURE__ */ new Set(), t = null;
  function n(i) {
    t && (!i.canMonitor || i.canMonitor(t.canMonitorArgs)) && t.active.add(i);
  }
  function r(i) {
    var s = Lo({}, i);
    e.add(s), n(s);
    function d() {
      e.delete(s), t && t.active.delete(s);
    }
    return te(d);
  }
  function a(i) {
    var s = i.eventName, d = i.payload;
    if (s === "onGenerateDragPreview") {
      t = {
        canMonitorArgs: {
          initial: d.location.initial,
          source: d.source
        },
        active: /* @__PURE__ */ new Set()
      };
      var c = xo(e), l;
      try {
        for (c.s(); !(l = c.n()).done; ) {
          var u = l.value;
          n(u);
        }
      } catch (h) {
        c.e(h);
      } finally {
        c.f();
      }
    }
    if (t) {
      for (var o = Array.from(t.active), v = 0, g = o; v < g.length; v++) {
        var f = g[v];
        if (t.active.has(f)) {
          var p;
          (p = f[s]) === null || p === void 0 || p.call(f, d);
        }
      }
      s === "onDrop" && (t.active.clear(), t = null);
    }
  }
  return {
    dispatchEvent: a,
    monitorForConsumers: r
  };
}
function Eo(e) {
  var t = e.typeKey, n = e.mount, r = e.dispatchEventToSource, a = e.onPostDispatch, i = e.defaultDropEffect, s = Co(), d = wo({
    typeKey: t,
    defaultDropEffect: i
  });
  function c(o) {
    r == null || r(o), d.dispatchEvent(o), s.dispatchEvent(o), a == null || a(o);
  }
  function l(o) {
    var v = o.event, g = o.dragType;
    Ht.start({
      event: v,
      dragType: g,
      getDropTargetsOver: d.getIsOver,
      dispatchEvent: c
    });
  }
  function u() {
    function o() {
      var v = {
        canStart: Ht.canStart,
        start: l
      };
      return n(v);
    }
    return bo({
      typeKey: t,
      mount: o
    });
  }
  return {
    registerUsage: u,
    dropTarget: d.dropTargetForConsumers,
    monitor: s.monitorForConsumers
  };
}
var ko = te(function() {
  return navigator.userAgent.toLocaleLowerCase().includes("android");
}), Po = "pdnd:android-fallback", Vt = "text/plain", Mo = "text/uri-list", Do = "application/vnd.pdnd", Ee = /* @__PURE__ */ new WeakMap();
function Oo(e) {
  return Ee.set(e.element, e), function() {
    Ee.delete(e.element);
  };
}
var Kt = to(), ft = Eo({
  typeKey: "element",
  defaultDropEffect: "move",
  mount: function(t) {
    return We(Kt.bindEvents(), me.bind(document, {
      type: "dragstart",
      listener: function(r) {
        var a, i, s, d, c, l;
        if (t.canStart(r) && !r.defaultPrevented) {
          if (!r.dataTransfer) {
            process.env.NODE_ENV !== "production" && console.warn(`
              It appears as though you have are not testing DragEvents correctly.

              - If you are unit testing, ensure you have polyfilled DragEvent.
              - If you are browser testing, ensure you are dispatching drag events correctly.

              Please see our testing guides for more information:
              https://atlassian.design/components/pragmatic-drag-and-drop/core-package/testing
            `.replace(/ {2}/g, ""));
            return;
          }
          var u = r.target;
          if (u instanceof HTMLElement) {
            var o = Ee.get(u);
            if (o) {
              var v = Se(r), g = {
                element: o.element,
                dragHandle: (a = o.dragHandle) !== null && a !== void 0 ? a : null,
                input: v
              };
              if (o.canDrag && !o.canDrag(g)) {
                r.preventDefault();
                return;
              }
              if (o.dragHandle) {
                var f = ut({
                  x: v.clientX,
                  y: v.clientY
                });
                if (!o.dragHandle.contains(f)) {
                  r.preventDefault();
                  return;
                }
              }
              var p = (i = (s = o.getInitialDataForExternal) === null || s === void 0 ? void 0 : s.call(o, g)) !== null && i !== void 0 ? i : null;
              if (p)
                for (var h = 0, y = Object.entries(p); h < y.length; h++) {
                  var x = xn(y[h], 2), L = x[0], b = x[1];
                  r.dataTransfer.setData(L, b ?? "");
                }
              ko() && !r.dataTransfer.types.includes(Vt) && !r.dataTransfer.types.includes(Mo) && r.dataTransfer.setData(Vt, Po), r.dataTransfer.setData(Do, "");
              var w = {
                element: o.element,
                dragHandle: (d = o.dragHandle) !== null && d !== void 0 ? d : null,
                data: (c = (l = o.getInitialData) === null || l === void 0 ? void 0 : l.call(o, g)) !== null && c !== void 0 ? c : {}
              }, S = {
                type: "element",
                payload: w,
                startedFrom: "internal"
              };
              t.start({
                event: r,
                dragType: S
              });
            }
          }
        }
      }
    }));
  },
  dispatchEventToSource: function(t) {
    var n, r, a = t.eventName, i = t.payload;
    (n = Ee.get(i.source.element)) === null || n === void 0 || (r = n[a]) === null || r === void 0 || r.call(
      n,
      // I cannot seem to get the types right here.
      // TS doesn't seem to like that one event can need `nativeSetDragImage`
      // @ts-expect-error
      i
    );
  },
  onPostDispatch: Kt.getOnPostDispatch()
}), Ao = ft.dropTarget, Mn = ft.monitor;
function Io(e) {
  if (process.env.NODE_ENV !== "production" && e.dragHandle && !e.element.contains(e.dragHandle) && console.warn("Drag handle element must be contained in draggable element", {
    element: e.element,
    dragHandle: e.dragHandle
  }), process.env.NODE_ENV !== "production") {
    var t = Ee.get(e.element);
    t && console.warn("You have already registered a `draggable` on the same element", {
      existing: t,
      proposed: e
    });
  }
  var n = We(
    // making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    ft.registerUsage(),
    Oo(e),
    Pn(e.element, {
      attribute: "draggable",
      value: "true"
    })
  );
  return te(n);
}
var ke = /* @__PURE__ */ new Map(), je = /* @__PURE__ */ new Set();
function Dn(e) {
  Ro(e);
  var t = ke.get(e);
  if (t)
    return t;
  var n = {
    timeOfEngagementStart: Date.now()
  };
  return ke.set(e, n), n;
}
function Ro(e) {
  je.add(e);
}
function jo(e) {
  je.clear(), e(), ke.forEach(function(t, n) {
    je.has(n) || ke.delete(n);
  }), je.clear();
}
function Wo() {
  ke.clear();
}
var $t = /* @__PURE__ */ new Map();
function Ho(e) {
  var t = $t.get(e);
  if (t)
    return t;
  var n = Fo(e);
  return $t.set(e, n), n;
}
function Fo(e) {
  var t = {
    type: "idle"
  }, n = [];
  function r(c) {
    if (t.type === "running") {
      var l = c - t.timeLastFrameFinished, u = t, o = u.latestArgs, v = ut({
        x: o.location.current.input.clientX,
        y: o.location.current.input.clientY
      });
      jo(function() {
        n.forEach(function(g) {
          return g({
            underUsersPointer: v,
            latestArgs: o,
            timeSinceLastFrame: l
          });
        });
      }), t.timeLastFrameFinished = c, t.frameId = requestAnimationFrame(r);
    }
  }
  function a() {
    t.type !== "idle" && (cancelAnimationFrame(t.frameId), Wo(), t = {
      type: "idle"
    });
  }
  function i(c) {
    t.type === "idle" && (t = {
      // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
      type: "initializing",
      latestArgs: c,
      frameId: requestAnimationFrame(function(l) {
        t.type === "initializing" && (t = {
          type: "running",
          timeLastFrameFinished: l,
          latestArgs: t.latestArgs,
          frameId: requestAnimationFrame(r)
        });
      })
    });
  }
  function s(c) {
    if (t.type === "idle") {
      i(c);
      return;
    }
    t.latestArgs = c;
  }
  e({
    onDragStart: i,
    onDropTargetChange: s,
    onDrag: s,
    onDrop: a
  });
  var d = {
    onFrame: function(l) {
      n.push(l);
    }
  };
  return d;
}
var rt = "data-auto-scrollable", zo = "[".concat(rt, '="true"]');
function No(e) {
  return e.setAttribute(rt, "true"), function() {
    return e.removeAttribute(rt);
  };
}
function Xt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Zt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xt(Object(n), !0).forEach(function(r) {
      _(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Bo = {
  startHitboxAtPercentageRemainingOfElement: {
    top: 0.25,
    right: 0.25,
    bottom: 0.25,
    left: 0.25
  },
  maxScrollAtPercentageRemainingOfHitbox: {
    top: 0.5,
    right: 0.5,
    bottom: 0.5,
    left: 0.5
  },
  timeDampeningDurationMs: 400,
  // Too big and it's too easy to trigger auto scrolling
  // Too small and it's too hard 😅
  maxMainAxisHitboxSize: 180
}, Vo = {
  // What the value would be if we were scrolling at 15px per frame at 60fps.
  // This is the default as it works well for most experiences.
  // In certain scenarios though it can feel a bit slow.
  standard: 900,
  // What the value would be if we were scrolling at 25px per frame at 60fps.
  // This is not the default as it feels too fast for a lot of experiences.
  fast: 1500
};
function On(e) {
  var t;
  return Zt(Zt({}, Bo), {}, {
    // only allowing limited control over the config at this stage
    maxPixelScrollPerSecond: Vo[(t = e == null ? void 0 : e.maxScrollSpeed) !== null && t !== void 0 ? t : "standard"]
  });
}
var Ko = {
  // Notes:
  //
  // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
  //    (and fractional units don't reach true integer maximum when zoomed in / out)
  // 🍎 Safari 16.5.2: no fractional units
  // 🦊 Firefox 115.0: no fractional units
  // we have some scroll we can move backwards into
  top: function(t) {
    return t.scrollTop > 0;
  },
  // We have some scroll we can move forward into
  right: function(t) {
    return Math.ceil(t.scrollLeft) + t.clientWidth < t.scrollWidth;
  },
  // We have some scroll we can move forwards into
  bottom: function(t) {
    return Math.ceil(t.scrollTop) + t.clientHeight < t.scrollHeight;
  },
  // we have some scroll we can move back into.
  left: function(t) {
    return t.scrollLeft > 0;
  }
}, $o = ["top", "right", "bottom", "left"], Xo = {
  top: "vertical",
  right: "horizontal",
  bottom: "vertical",
  left: "horizontal"
}, Ut = {
  start: "top",
  end: "bottom",
  point: "y",
  size: "height"
}, Yt = {
  start: "left",
  end: "right",
  point: "x",
  size: "width"
}, An = {
  vertical: {
    mainAxis: Ut,
    crossAxis: Yt
  },
  horizontal: {
    mainAxis: Yt,
    crossAxis: Ut
  }
}, mt = {
  top: "start",
  right: "end",
  bottom: "end",
  left: "start"
};
function Ie(e) {
  var t = e.edge, n = e.axis;
  return function(a) {
    var i = a.clientRect, s = a.config, d = An[n], c = d.mainAxis, l = d.crossAxis, u = mt[t], o = Math.min(
      // scale the size of the hitbox down for smaller elements
      s.startHitboxAtPercentageRemainingOfElement[t] * i[c.size],
      // Don't let the hitbox grow too big for big elements
      s.maxMainAxisHitboxSize
    );
    return DOMRect.fromRect(_(_(_(_({}, c.point, u === "start" ? (
      // begin from the start edge and grow inwards
      i[c.point]
    ) : (
      // begin from inside the end edge and grow towards the end edge
      i[c.point] + i[c.size] - o
    )), l.point, i[l.point]), c.size, o), l.size, i[l.size]));
  };
}
var Zo = {
  top: Ie({
    axis: "vertical",
    edge: "top"
  }),
  right: Ie({
    axis: "horizontal",
    edge: "right"
  }),
  bottom: Ie({
    axis: "vertical",
    edge: "bottom"
  }),
  left: Ie({
    axis: "horizontal",
    edge: "left"
  })
};
function ot(e) {
  var t = e.startOfRange, n = e.endOfRange, r = e.value, a = t < n;
  if (!a || r < t)
    return 0;
  if (r > n)
    return 1;
  var i = n - t;
  return (r - t) / i;
}
function Uo(e) {
  var t = e.timeSinceLastFrame, n = e.config, r = n.maxPixelScrollPerSecond / 1e3, a = Math.ceil(r * t), i = n.maxPixelScrollPerSecond / 60;
  return Math.min(a, i);
}
function Yo(e) {
  var t = e.client, n = e.axis, r = e.edge, a = e.hitbox, i = e.config, s = An[n].mainAxis, d = mt[r], c = a[s.size] * i.maxScrollAtPercentageRemainingOfHitbox[r];
  if (d === "end")
    return ot({
      startOfRange: a[s.start],
      endOfRange: a[s.end] - c,
      value: t[s.point]
    });
  var l = ot({
    startOfRange: a[s.start] + c,
    endOfRange: a[s.end],
    value: t[s.point]
  });
  return 1 - l;
}
function Re(e) {
  var t = e.client, n = e.timeSinceLastFrame, r = e.engagement, a = e.axis, i = e.hitbox, s = e.edge, d = e.isDistanceDampeningEnabled, c = e.config, l = Uo({
    timeSinceLastFrame: n,
    config: c
  }), u = d ? Yo({
    client: t,
    edge: s,
    hitbox: i,
    axis: a,
    config: c
  }) : 1, o = ot({
    startOfRange: r.timeOfEngagementStart,
    endOfRange: r.timeOfEngagementStart + c.timeDampeningDurationMs,
    value: Date.now()
  }), v = u * o, g = Math.max(l * v, 1), f = mt[s];
  return f === "end" ? g : -1 * g;
}
function _o(e, t) {
  return t === "all" || e === t;
}
function Go(e) {
  var t = e.client, n = e.clientRect;
  return (
    // is within horizontal bounds
    t.x >= n.x && t.x <= n.x + n.width && // is within vertical bounds
    t.y >= n.y && t.y <= n.y + n.height
  );
}
function qo(e) {
  return e.getBoundingClientRect();
}
function In(e) {
  var t = e.element, n = e.input, r = e.timeSinceLastFrame, a = e.engagement, i = e.config, s = e.allowedAxis, d = e.getRect, c = d === void 0 ? qo : d, l = {
    x: n.clientX,
    y: n.clientY
  }, u = c(t), o = $o.reduce(function(f, p) {
    var h = Zo[p]({
      clientRect: u,
      config: i
    }), y = Xo[p];
    return !_o(y, s) || !Go({
      client: l,
      clientRect: h
    }) || !Ko[p](t) || f.set(p, {
      edge: p,
      hitbox: h
    }), f;
  }, /* @__PURE__ */ new Map()), v = (function() {
    var f = "horizontal", p = o.get("left");
    if (p)
      return Re({
        client: l,
        edge: p.edge,
        hitbox: p.hitbox,
        axis: f,
        timeSinceLastFrame: r,
        engagement: a,
        isDistanceDampeningEnabled: !0,
        config: i
      });
    var h = o.get("right");
    return h ? Re({
      client: l,
      edge: h.edge,
      hitbox: h.hitbox,
      axis: f,
      timeSinceLastFrame: r,
      engagement: a,
      isDistanceDampeningEnabled: !0,
      config: i
    }) : 0;
  })(), g = (function() {
    var f = "vertical", p = o.get("bottom");
    if (p)
      return Re({
        client: l,
        edge: p.edge,
        hitbox: p.hitbox,
        axis: f,
        timeSinceLastFrame: r,
        engagement: a,
        isDistanceDampeningEnabled: !0,
        config: i
      });
    var h = o.get("top");
    return h ? Re({
      client: l,
      edge: h.edge,
      hitbox: h.hitbox,
      axis: f,
      timeSinceLastFrame: r,
      engagement: a,
      isDistanceDampeningEnabled: !0,
      config: i
    }) : 0;
  })();
  return {
    left: v,
    top: g
  };
}
function Qo(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Jo(e)) || t) {
      n && (e = n);
      var r = 0, a = function() {
      };
      return { s: a, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(l) {
        throw l;
      }, f: a };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, s = !0, d = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var l = n.next();
    return s = l.done, l;
  }, e: function(l) {
    d = !0, i = l;
  }, f: function() {
    try {
      s || n.return == null || n.return();
    } finally {
      if (d) throw i;
    }
  } };
}
function Jo(e, t) {
  if (e) {
    if (typeof e == "string") return _t(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _t(e, t) : void 0;
  }
}
function _t(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Rn(e) {
  return !!(e.top || e.left);
}
function jn(e) {
  var t, n, r, a = e.target, i = e.input, s = e.source, d = e.findEntry, c = e.timeSinceLastFrame, l = e.available, u = l === void 0 ? {
    top: !0,
    left: !0
  } : l;
  if (!Rn(u) || !a)
    return u;
  var o = a.closest(zo);
  if (!o)
    return u;
  var v = d(o);
  if (!v)
    return u;
  function g() {
    var b;
    return jn({
      target: (b = o == null ? void 0 : o.parentElement) !== null && b !== void 0 ? b : null,
      findEntry: d,
      source: s,
      timeSinceLastFrame: c,
      input: i,
      available: u
    });
  }
  var f = {
    input: i,
    source: s,
    element: o
  };
  if (v.canScroll && !v.canScroll(f))
    return g();
  var p = Dn(o), h = On((t = v.getConfiguration) === null || t === void 0 ? void 0 : t.call(v, f)), y = (n = (r = v.getAllowedAxis) === null || r === void 0 ? void 0 : r.call(v, f)) !== null && n !== void 0 ? n : "all", x = In({
    element: o,
    engagement: p,
    input: i,
    timeSinceLastFrame: c,
    allowedAxis: y,
    config: h
  }), L = {
    top: 0,
    left: 0
  };
  return u.top && x.top !== 0 && (L.top = x.top, u.top = !1), u.left && x.left !== 0 && (L.left = x.left, u.left = !1), (L.top !== 0 || L.left !== 0) && o.scrollBy(L), g();
}
function ei(e) {
  var t = e.input, n = e.timeSinceLastFrame, r = e.available, a = e.source, i = e.entries, s = document.documentElement, d = {
    input: t,
    source: a,
    element: s
  }, c = Qo(i), l;
  try {
    for (c.s(); !(l = c.n()).done; ) {
      var u, o, v, g = l.value;
      if (!(g.canScroll && !g.canScroll(d))) {
        var f = Dn(s), p = On((u = g.getConfiguration) === null || u === void 0 ? void 0 : u.call(g, d)), h = (o = (v = g.getAllowedAxis) === null || v === void 0 ? void 0 : v.call(g, d)) !== null && o !== void 0 ? o : "all", y = In({
          element: s,
          engagement: f,
          input: t,
          config: p,
          allowedAxis: h,
          getRect: function(b) {
            return DOMRect.fromRect({
              y: 0,
              x: 0,
              width: b.clientWidth,
              height: b.clientHeight
            });
          },
          timeSinceLastFrame: n
        }), x = {
          top: r.top ? y.top : 0,
          left: r.left ? y.left : 0
        };
        (x.top !== 0 || x.left !== 0) && s.scrollBy(x);
        break;
      }
    }
  } catch (L) {
    c.e(L);
  } finally {
    c.f();
  }
}
function ti(e) {
  var t = e.input, n = e.findEntry, r = e.timeSinceLastFrame, a = e.source, i = e.getWindowScrollEntries, s = e.underUsersPointer, d = jn({
    target: s,
    timeSinceLastFrame: r,
    input: t,
    source: a,
    findEntry: n
  });
  Rn(d) && ei({
    input: t,
    source: a,
    entries: i(),
    timeSinceLastFrame: r,
    available: d
  });
}
function Gt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ni(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gt(Object(n), !0).forEach(function(r) {
      _(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ri(e) {
  var t = e.monitor, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set();
  function a(l) {
    if (process.env.NODE_ENV !== "production") {
      var u = window.getComputedStyle(l.element), o = u.overflowX, v = u.overflowY, g = o === "auto" || o === "scroll" || v === "auto" || v === "scroll";
      g || console.warn("Auto scrolling has been attached to an element that appears not to be scrollable", {
        element: l.element,
        overflowX: o,
        overflowY: v
      });
    }
    if (process.env.NODE_ENV !== "production") {
      var f = n.get(l.element);
      f && console.warn("You have already registered autoScrolling on the same element", {
        existing: f,
        proposed: l
      });
    }
    n.set(l.element, l);
    var p = We(No(l.element), function() {
      return n.delete(l.element);
    });
    return te(p);
  }
  function i() {
    var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = ni({}, l);
    r.add(u);
    function o() {
      r.delete(u);
    }
    return te(o);
  }
  function s(l) {
    var u;
    return (u = n.get(l)) !== null && u !== void 0 ? u : null;
  }
  function d() {
    return Array.from(r);
  }
  function c(l) {
    var u = l.latestArgs, o = l.underUsersPointer, v = l.timeSinceLastFrame;
    ti({
      input: u.location.current.input,
      source: u.source,
      findEntry: s,
      underUsersPointer: o,
      timeSinceLastFrame: v,
      getWindowScrollEntries: d
    });
  }
  return Ho(t).onFrame(c), {
    autoScroll: a,
    autoScrollWindow: i
  };
}
var oi = ri({
  monitor: Mn
}), ii = oi.autoScroll;
function ai(e) {
  const { store: t } = K(), n = C((i) => i.setZoomLevel), r = C((i) => i.setScrollPosition), a = O(
    (i) => {
      if (!i.ctrlKey && !i.metaKey) return;
      i.preventDefault();
      const s = t.getState(), d = hn(s), { currentTime: c, duration: l, zoomLevel: u, scrollPosition: o } = s;
      if (l === 0) return;
      const g = Math.pow(2, -i.deltaY * 5e-3), f = u * g, p = Math.max(ce, Math.min(f, d));
      if (p === u) return;
      const h = e.current;
      if (!h) return;
      const y = p / u, { newScroll: x } = un(
        u,
        y,
        c,
        o,
        l,
        h.getBoundingClientRect().width
      );
      n(p), r(x);
    },
    [e, n, r, t]
  );
  B(() => {
    const i = e.current;
    if (i)
      return i.addEventListener("wheel", a, { passive: !1 }), () => {
        i.removeEventListener("wheel", a);
      };
  }, [e, a]);
}
function ci(e) {
  const { store: t } = K(), n = O(
    (l) => {
      if (l.ctrlKey || l.metaKey || !l.shiftKey && Math.abs(l.deltaX) <= 0)
        return;
      const u = Math.abs(l.deltaX) > 0 ? l.deltaX : l.deltaY;
      l.preventDefault();
      const { scrollPosition: o, duration: v, setScrollPosition: g } = t.getState(), f = Z(t.getState()), p = xe(t.getState()), h = u / f, y = o + h, x = le(v, p, f);
      g(Math.max(0, Math.min(y, x)));
    },
    [t]
  ), r = R(!1), a = R(0), i = R(0), s = O(
    (l) => {
      l.button === 1 && (l.preventDefault(), r.current = !0, a.current = l.clientX, i.current = t.getState().scrollPosition, document.body.style.cursor = "grabbing");
    },
    [t]
  ), d = O(
    (l) => {
      if (!r.current) return;
      const u = a.current - l.clientX, { duration: o, setScrollPosition: v } = t.getState(), g = Z(t.getState()), f = xe(t.getState()), p = u / g, h = i.current + p, y = le(o, f, g);
      v(Math.max(0, Math.min(h, y)));
    },
    [t]
  ), c = O(() => {
    r.current && (r.current = !1, document.body.style.cursor = "");
  }, []);
  B(() => {
    const l = e.current;
    if (l)
      return l.addEventListener("wheel", n, { passive: !1 }), l.addEventListener("mousedown", s), document.addEventListener("mousemove", d), document.addEventListener("mouseup", c), () => {
        l.removeEventListener("wheel", n), l.removeEventListener("mousedown", s), document.removeEventListener("mousemove", d), document.removeEventListener("mouseup", c);
      };
  }, [e, n, s, d, c]);
}
function si(e, t) {
  B(() => {
    const n = e.current, r = t.current;
    if (!n || !r) return;
    const a = () => {
      r.scrollTop = n.scrollTop;
    }, i = () => {
      n.scrollTop = r.scrollTop;
    };
    return n.addEventListener("scroll", a), r.addEventListener("scroll", i), () => {
      n.removeEventListener("scroll", a), r.removeEventListener("scroll", i);
    };
  }, [e, t]);
}
function H(e) {
  return e === "video" || e === "audio";
}
function li(e, t, n, r, a) {
  const i = Math.round(e * a) / a;
  let s = i, d = r, c = null;
  for (const l of n) {
    const u = Math.abs(i - l);
    u < d && (d = u, s = l, c = l);
    const o = Math.abs(i + t - l);
    o < d && (d = o, s = l - t, c = l);
  }
  return { startTime: s, snapIndicator: c };
}
function ui(e, t, n, r, a, i, s, d) {
  const c = 1 / d;
  let l = t + e, u = a;
  if (H(n) && (u = a - e, u < 0 && (l = t + a, u = 0)), l < c) {
    const p = c - l;
    l = c, H(n) && (u += p);
  }
  const o = r + l, { snappedEdge: v, snapIndicator: g } = pt(o, i, s), f = v - o;
  return f !== 0 && (l += f, H(n) && (u -= f), H(n) && u < 0 && (l += u, u = 0), l < c && (H(n) && (u += c - l), l = c)), l = Math.round(l * d) / d, H(n) && (u = t + a - l), { duration: l, trimEnd: u, snapIndicator: g };
}
function di(e, t, n, r, a, i, s, d) {
  const c = 1 / d;
  let l = r + e, u = t - e, o = a;
  if (H(n) && (o = a + e, o < 0 && (l = r - a, u = t + a, o = 0)), l < 0) {
    const h = -l;
    l = 0, u -= h, H(n) && (o += h);
  }
  if (u < c) {
    const h = c - u;
    u = c, l -= h, H(n) && (o -= h), l < 0 && (l = 0), H(n) && o < 0 && (o = 0);
  }
  const v = l, { snappedEdge: g, snapIndicator: f } = pt(v, i, s), p = g - v;
  if (p !== 0 && (l += p, u -= p, H(n) && (o += p), H(n) && o < 0 && (l -= o, u += o, o = 0), l < 0 && (u += l, H(n) && (o -= l), l = 0), u < c)) {
    const h = c - u;
    u = c, l -= h, H(n) && (o -= h), l < 0 && (l = 0), H(n) && o < 0 && (o = 0);
  }
  return l = Math.round(l * d) / d, u = r + t - l, H(n) && (o = a + t - u), { startTime: l, duration: u, trimStart: o, snapIndicator: f };
}
function Wn(e, t, n, r = []) {
  const a = [...r];
  for (const i of e)
    i.id !== t && a.push(i.startTime, Math.round((i.startTime + i.duration) * n) / n);
  return a;
}
function pt(e, t, n) {
  let r = e, a = n, i = null;
  for (const s of t) {
    const d = Math.abs(e - s);
    d < a && (a = d, r = s, i = s);
  }
  return { snappedEdge: r, snapIndicator: i };
}
const fi = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m("path", { d: "M12 5.25V18.75", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M5.25 8.25V5.25H18.75V8.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m("path", { d: "M9 18.75H15", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" })
] }), mi = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M5.31494 20.2499L15.5946 9.96923C15.6643 9.8995 15.747 9.84418 15.838 9.80644C15.9291 9.76869 16.0267 9.74927 16.1253 9.74927C16.2238 9.74927 16.3214 9.76869 16.4125 9.80644C16.5035 9.84418 16.5862 9.8995 16.6559 9.96923L20.2503 13.5645",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), pi = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M14.8 12.5L10 9.5V15.5L14.8 12.5Z",
      stroke: "currentColor",
      strokeWidth: "1.13",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M20.1818 5H3.81818C3.36631 5 3 5.47969 3 6.07143V18.9286C3 19.5203 3.36631 20 3.81818 20H20.1818C20.6337 20 21 19.5203 21 18.9286V6.07143C21 5.47969 20.6337 5 20.1818 5Z",
      stroke: "currentColor",
      strokeWidth: "1.13",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), gi = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M12 5.25C4.5 5.25 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C19.5 18.75 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), hi = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M3 9.75C4.57594 11.7009 7.46531 14.25 12 14.25C16.5347 14.25 19.4241 11.7009 21 9.75",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M21 15.7499L18.8081 11.9146",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M15.0001 17.9998L14.3354 14.0107",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M9 17.9998L9.66469 14.0107",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M3 15.7499L5.19187 11.9146",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), vi = ({
  onToggle: e,
  hidden: t,
  disabled: n
}) => /* @__PURE__ */ m(se, { size: 20, disabled: n, onClick: e, stopPropagation: !0, children: t ? /* @__PURE__ */ m(hi, { width: 14, height: 14 }) : /* @__PURE__ */ m(gi, { width: 14, height: 14 }) }), yi = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M8.25 8.25V5.25C8.25 4.25544 8.64509 3.30161 9.34835 2.59835C10.0516 1.89509 11.0054 1.5 12 1.5C12.9946 1.5 13.9484 1.89509 14.6517 2.59835C15.3549 3.30161 15.75 4.25544 15.75 5.25V8.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), bi = ({ title: e, ...t }) => /* @__PURE__ */ P("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ m("title", { children: e }) : null,
  /* @__PURE__ */ m(
    "path",
    {
      d: "M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ m(
    "path",
    {
      d: "M8.25 8.25V5.25C8.25 4.25544 8.64509 3.30161 9.34835 2.59835C10.0516 1.89509 11.0054 1.5 12 1.5C13.8141 1.5 15.4022 2.78812 15.75 4.5",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Si = ({
  onToggle: e,
  locked: t,
  disabled: n
}) => /* @__PURE__ */ m(se, { size: 20, disabled: n, onClick: e, stopPropagation: !0, children: t ? /* @__PURE__ */ m(yi, { width: 14, height: 14 }) : /* @__PURE__ */ m(bi, { width: 14, height: 14 }) });
function wi() {
  const e = C((p) => p.zoomLevel), t = C(hn), n = C((p) => p.setZoomLevel), r = C((p) => p.scrollPosition), a = C((p) => p.currentTime), i = C((p) => p.duration), s = C((p) => p.containerWidth), d = C((p) => p.setScrollPosition), c = (p) => {
    const h = p / e, { newScroll: y } = un(e, h, a, r, i, s);
    n(p), d(y);
  }, l = () => {
    c(Math.min(e * xt, t));
  }, u = () => {
    c(Math.max(e / xt, ce));
  }, o = Math.log(ce), v = Math.log(Math.max(t, ce + pr)), g = (Math.log(e) - o) / (v - o), f = (p) => {
    const h = parseFloat(p.target.value), y = Math.exp(o + h * (v - o));
    c(y);
  };
  return /* @__PURE__ */ P(J, { style: { gap: 4, height: "100%", paddingRight: "8px" }, onMouseDown: (p) => p.stopPropagation(), children: [
    /* @__PURE__ */ m(
      ue,
      {
        component: "button",
        className: "zoom-button",
        style: {
          width: 12,
          height: 12,
          flexShrink: 0,
          padding: 0,
          border: "none",
          borderRadius: "50%",
          background: "transparent",
          color: Te,
          cursor: "pointer"
        },
        onClick: u,
        disabled: e <= ce,
        "aria-label": "Zoom out",
        children: /* @__PURE__ */ P("svg", { viewBox: "0 0 12 12", width: "12", height: "12", children: [
          /* @__PURE__ */ m("circle", { cx: "6", cy: "6", r: "5", fill: "none", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ m("line", { x1: "3.5", y1: "6", x2: "8.5", y2: "6", stroke: "currentColor", strokeWidth: "1.2" })
        ] })
      }
    ),
    /* @__PURE__ */ m(
      "input",
      {
        className: "zoom-slider",
        type: "range",
        min: "0",
        max: "1",
        step: "0.001",
        value: g,
        onChange: f,
        "aria-label": "Zoom level",
        style: {
          WebkitAppearance: "none",
          appearance: "none",
          flex: 1,
          minWidth: 0,
          height: 6,
          borderRadius: 3,
          background: N,
          outline: "none",
          cursor: "pointer"
        }
      }
    ),
    /* @__PURE__ */ m(
      ue,
      {
        component: "button",
        className: "zoom-button",
        style: {
          width: 12,
          height: 12,
          flexShrink: 0,
          padding: 0,
          border: "none",
          borderRadius: "50%",
          background: "transparent",
          color: Te,
          cursor: "pointer"
        },
        onClick: l,
        disabled: e >= t,
        "aria-label": "Zoom in",
        children: /* @__PURE__ */ P("svg", { viewBox: "0 0 12 12", width: "12", height: "12", children: [
          /* @__PURE__ */ m("circle", { cx: "6", cy: "6", r: "5", fill: "none", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ m("line", { x1: "3.5", y1: "6", x2: "8.5", y2: "6", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ m("line", { x1: "6", y1: "3.5", x2: "6", y2: "8.5", stroke: "currentColor", strokeWidth: "1.2" })
        ] })
      }
    )
  ] });
}
const xi = 4, qt = pn * 2 + mn + xi;
function Ti() {
  const e = C((y) => y.scrollPosition), t = C((y) => y.duration), n = C((y) => y.containerWidth), r = C(xe), a = C(Z), i = C((y) => y.setScrollPosition), { store: s } = K(), d = R(null), c = Math.max(0, n - qt), l = t > 0 ? r / t : 1, u = Math.max(wt, c * l), o = le(t, r, a), v = o > 0 ? e / o * (c - u) : 0, g = R({ active: !1, startMouseX: 0, startThumbLeft: 0 }), f = R(null);
  if (B(() => {
    const y = (L) => {
      if (!g.current.active) return;
      const b = s.getState(), { duration: w, containerWidth: S, setScrollPosition: T } = b, E = xe(b), M = Z(b), I = Math.max(0, S - qt), k = w > 0 ? E / w : 1, D = Math.max(wt, I * k), A = le(w, E, M), F = L.clientX - g.current.startMouseX, z = I - D;
      if (z <= 0) return;
      const V = Math.max(0, Math.min(g.current.startThumbLeft + F, z)) / z;
      T(V * A);
    }, x = () => {
      g.current.active && (g.current.active = !1, document.removeEventListener("mousemove", y), document.removeEventListener("mouseup", x));
    };
    f.current = { onMouseMove: y, onMouseUp: x };
  }, [s]), r >= t) return null;
  function p(y) {
    if (y.button !== 0) return;
    y.stopPropagation();
    const x = f.current;
    x && (g.current = {
      active: !0,
      startMouseX: y.clientX,
      startThumbLeft: v
    }, document.addEventListener("mousemove", x.onMouseMove), document.addEventListener("mouseup", x.onMouseUp));
  }
  function h(y) {
    const x = d.current;
    if (!x) return;
    const L = x.getBoundingClientRect(), b = y.clientX - L.left, w = c - u;
    if (w <= 0) return;
    const T = Math.max(0, Math.min(b - u / 2, w)) / w;
    i(T * o);
  }
  return /* @__PURE__ */ m(
    "div",
    {
      ref: d,
      className: "timeline-scrollbar",
      style: {
        position: "relative",
        flex: 1,
        minWidth: 0,
        height: 6,
        margin: "auto 4px auto 0",
        background: N,
        borderRadius: 3,
        cursor: "pointer"
      },
      onMouseDown: h,
      children: /* @__PURE__ */ m(
        "div",
        {
          style: {
            position: "absolute",
            top: 0,
            height: "100%",
            borderRadius: 3,
            background: fe,
            cursor: "grab",
            transition: "background 0.15s",
            width: u,
            left: v
          },
          onMouseDown: p
        }
      )
    }
  );
}
function Li(e) {
  return e.type === "video" ? { background: Er } : e.type === "audio" ? { background: kr } : e.type === "text" ? { background: Cr } : {
    background: `url(${e.thumbnailUrl})`,
    backgroundSize: "32px 32px",
    backgroundRepeat: "repeat"
  };
}
function qe(e, t) {
  const n = t.getBoundingClientRect();
  return e - n.left < bt ? "trim-left" : n.right - e < bt ? "trim-right" : "move";
}
function Ci({ track: e, isSelected: t }) {
  const n = C((k) => k.scrollPosition), r = C((k) => k.containerWidth), a = C(Z), i = C((k) => k.setTrackTrim), { store: s, onTrackStartTimeChange: d, onTrackTrimChange: c, onTrackSelect: l } = K(), u = R({
    active: !1,
    mode: "move",
    trackId: -1,
    trackType: "image",
    trackDuration: 0,
    initialStartTime: 0,
    initialTrimStart: 0,
    initialTrimEnd: 0,
    mouseDownClientX: 0,
    lastSnappedStartTime: 0,
    // For trim: track last-applied values to avoid duplicate updates
    lastDuration: 0,
    lastTrimStart: 0,
    lastTrimEnd: 0
  }), o = O(
    (k) => {
      if (k.button !== 0 || (k.stopPropagation(), e.locked)) return;
      document.activeElement instanceof HTMLElement && document.activeElement.blur(), l(e.id);
      const D = k.currentTarget, A = qe(k.clientX, D);
      u.current = {
        active: !0,
        mode: A,
        trackId: e.id,
        trackType: e.type,
        trackDuration: e.duration,
        initialStartTime: e.startTime,
        initialTrimStart: e.trimStart ?? 0,
        initialTrimEnd: e.trimEnd ?? 0,
        mouseDownClientX: k.clientX,
        lastSnappedStartTime: e.startTime,
        lastDuration: e.duration,
        lastTrimStart: e.trimStart ?? 0,
        lastTrimEnd: e.trimEnd ?? 0
      };
      const { setDraggingTrackId: F } = s.getState();
      F(e.id), A === "move" ? document.body.classList.add("timeline-dragging") : document.body.classList.add("timeline-trimming");
      const z = (V) => {
        if (!u.current.active) return;
        const ne = s.getState(), { frameRate: re, setTrackStartTime: pe, setTrackTrim: Pe, setSnapIndicatorTime: ge } = ne, ae = Z(ne), Me = V.clientX - u.current.mouseDownClientX, He = ae > 0 ? Me / ae : 0, Fe = (V.shiftKey ? fn : dn) / ae, { tracks: Hn, currentTime: Fn, duration: zn } = s.getState(), ze = Wn(Hn, u.current.trackId, re, [
          Fn,
          0,
          zn
        ]), { mode: Ne, trackType: De, initialStartTime: he, initialTrimStart: gt, initialTrimEnd: ht, trackDuration: Be } = u.current;
        if (Ne === "move") {
          const W = he + He, $ = li(W, Be, ze, Fe, re);
          if (ge($.snapIndicator), $.startTime === u.current.lastSnappedStartTime) return;
          u.current.lastSnappedStartTime = $.startTime, pe(u.current.trackId, $.startTime), d(u.current.trackId, $.startTime, !0);
        } else if (Ne === "trim-right") {
          const W = ui(
            He,
            Be,
            De,
            he,
            ht,
            ze,
            Fe,
            re
          );
          if (ge(W.snapIndicator), W.duration === u.current.lastDuration && W.trimEnd === u.current.lastTrimEnd)
            return;
          u.current.lastDuration = W.duration, u.current.lastTrimEnd = W.trimEnd, u.current.lastSnappedStartTime = he;
          const $ = {
            startTime: he,
            duration: W.duration,
            ...H(De) ? { trimStart: gt, trimEnd: W.trimEnd } : {}
          };
          Pe(u.current.trackId, $), c(u.current.trackId, $, !0);
        } else if (Ne === "trim-left") {
          const W = di(
            He,
            Be,
            De,
            he,
            gt,
            ze,
            Fe,
            re
          );
          if (ge(W.snapIndicator), W.startTime === u.current.lastSnappedStartTime && W.duration === u.current.lastDuration && W.trimStart === u.current.lastTrimStart)
            return;
          u.current.lastSnappedStartTime = W.startTime, u.current.lastDuration = W.duration, u.current.lastTrimStart = W.trimStart;
          const $ = {
            startTime: W.startTime,
            duration: W.duration,
            ...H(De) ? { trimStart: W.trimStart, trimEnd: ht } : {}
          };
          Pe(u.current.trackId, $), c(u.current.trackId, $, !0);
        }
      }, j = () => {
        if (!u.current.active) return;
        const { mode: V } = u.current;
        u.current.active = !1, document.body.classList.remove("timeline-dragging"), document.body.classList.remove("timeline-trimming");
        const { setSnapIndicatorTime: ne, setDraggingTrackId: re } = s.getState();
        if (ne(null), re(null), V === "move")
          d(u.current.trackId, u.current.lastSnappedStartTime, !1);
        else {
          const pe = {
            startTime: u.current.lastSnappedStartTime,
            duration: u.current.lastDuration,
            ...H(u.current.trackType) ? { trimStart: u.current.lastTrimStart, trimEnd: u.current.lastTrimEnd } : {}
          };
          c(u.current.trackId, pe, !1);
        }
        document.removeEventListener("mousemove", z), document.removeEventListener("mouseup", j);
      };
      document.addEventListener("mousemove", z), document.addEventListener("mouseup", j);
    },
    [e, l, d, c, s]
  ), v = O(
    (k) => {
      if (e.locked) return;
      const D = k.currentTarget, A = qe(k.clientX, D), F = e.trimStart ?? 0, z = e.trimEnd ?? 0;
      let j = null;
      A === "trim-left" && F > 0 ? j = {
        startTime: e.startTime - F,
        duration: e.duration + F,
        trimStart: 0,
        trimEnd: z
      } : A === "trim-right" && z > 0 && (j = {
        startTime: e.startTime,
        duration: e.duration + z,
        trimStart: F,
        trimEnd: 0
      }), j && (i(e.id, j), c(e.id, j, !1));
    },
    [e, i, c]
  ), g = O(
    (k) => {
      if (e.locked || u.current.active) return;
      const D = k.currentTarget, A = qe(k.clientX, D);
      D.style.cursor = A === "move" ? "grab" : "ew-resize";
    },
    [e.locked]
  ), f = O(
    (k) => {
      if (u.current.active) return;
      const D = k.currentTarget;
      D.style.cursor = e.locked ? "not-allowed" : "grab";
    },
    [e.locked]
  ), p = (e.startTime - n) * a, h = p + e.duration * a, y = Math.max(0, p), x = Math.max(0, Math.min(h, r) - y), L = Li(e), b = y - p, w = e.trimStart ?? 0, S = e.trimEnd ?? 0, T = w * a, E = p - T, M = h, I = S * a;
  return /* @__PURE__ */ P(
    "div",
    {
      "data-track-id": e.id,
      style: {
        position: "relative",
        height: lt,
        background: X,
        borderBottom: `1px solid ${N}`,
        boxSizing: "border-box"
      },
      children: [
        w > 0 && /* @__PURE__ */ m(
          "div",
          {
            style: {
              position: "absolute",
              height: $e,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: `${ve}px 0 0 ${ve}px`,
              pointerEvents: "none",
              left: Math.max(0, E),
              width: Math.max(0, Math.min(E + T, r) - Math.max(0, E)),
              background: L.background,
              backgroundSize: L.backgroundSize,
              backgroundRepeat: L.backgroundRepeat,
              opacity: St
            }
          }
        ),
        e.duration > 0 && /* @__PURE__ */ m(
          "div",
          {
            className: `timeline-track-clip${t ? " selected" : ""}`,
            style: {
              position: "absolute",
              height: $e,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: ve,
              overflow: "hidden",
              cursor: e.locked ? "not-allowed" : "grab",
              left: y,
              width: x,
              background: L.background,
              backgroundSize: L.backgroundSize,
              backgroundRepeat: L.backgroundRepeat,
              backgroundPosition: b > 0 ? `${-b}px 0` : void 0,
              opacity: e.hidden || e.type === "audio" && e.muted ? 0.5 : void 0
            },
            onMouseDown: o,
            onDoubleClick: v,
            onMouseMove: g,
            onMouseLeave: f,
            children: e.label && /* @__PURE__ */ m(
              J,
              {
                component: "span",
                style: {
                  height: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  pointerEvents: "none",
                  userSelect: "none",
                  ...e.type === "text" ? { alignItems: "flex-start", padding: "4px 8px 0", color: wr } : { padding: "0 6px", color: X },
                  ...b > 0 ? { marginLeft: -b } : void 0
                },
                children: e.type === "text" && /* @__PURE__ */ m(Wr, { text: e.label })
              }
            )
          }
        ),
        S > 0 && /* @__PURE__ */ m(
          "div",
          {
            style: {
              position: "absolute",
              height: $e,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: `0 ${ve}px ${ve}px 0`,
              pointerEvents: "none",
              left: Math.max(0, M),
              width: Math.max(0, Math.min(M + I, r) - Math.max(0, M)),
              background: L.background,
              backgroundSize: L.backgroundSize,
              backgroundRepeat: L.backgroundRepeat,
              opacity: St
            }
          }
        )
      ]
    }
  );
}
function Ei() {
  const e = C((i) => i.snapIndicatorTime), t = C((i) => i.scrollPosition), n = C(Z), r = C((i) => i.containerWidth);
  if (e === null) return null;
  const a = (e - t) * n;
  return a < -1 || a > r + 1 ? null : /* @__PURE__ */ m(
    "div",
    {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 9,
        transform: `translateX(${a}px)`
      },
      children: /* @__PURE__ */ m(
        "div",
        {
          style: {
            position: "absolute",
            top: q,
            left: 0,
            width: 1,
            bottom: 0,
            background: de
          }
        }
      )
    }
  );
}
const ki = 15, Qt = q - ki;
function Pi() {
  const e = C((s) => s.currentTime), t = C((s) => s.scrollPosition), n = C(Z), r = (e - t) * n, a = C((s) => s.duration), i = C((s) => s.containerWidth);
  return a === 0 || r < -10 || r > i + 10 ? null : /* @__PURE__ */ P(
    "div",
    {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 10,
        transform: `translateX(${r}px)`
      },
      children: [
        /* @__PURE__ */ m(
          "div",
          {
            style: {
              position: "absolute",
              top: Qt,
              left: -6,
              width: 12,
              height: 8,
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderTop: `8px solid ${de}`,
              pointerEvents: "auto"
            }
          }
        ),
        /* @__PURE__ */ m(
          "div",
          {
            style: {
              position: "absolute",
              top: Qt,
              left: -1,
              width: 1,
              bottom: 0,
              background: de
            }
          }
        )
      ]
    }
  );
}
function Mi() {
  const e = C((c) => c.duration), t = C((c) => c.frameRate), n = C((c) => c.scrollPosition), r = C((c) => c.containerWidth), a = C(xe), i = C(Z), { ticks: s, majorInterval: d } = Qe(() => {
    if (e === 0 || r === 0) return { ticks: [], majorInterval: 0 };
    const { start: c, end: l } = ir(n, a, e), { interval: u, majorInterval: o } = lr(i, t);
    return {
      ticks: ur(c, l, u, o, t),
      majorInterval: o
    };
  }, [e, t, n, a, i, r]);
  return e === 0 ? /* @__PURE__ */ m("div", { style: { display: "block", borderBottom: `1px solid ${N}`, height: q }, children: /* @__PURE__ */ m(ue, { component: "span", style: { height: "100%" }, children: /* @__PURE__ */ m(Ir, { text: "No timeline data" }) }) }) : /* @__PURE__ */ P(
    "svg",
    {
      width: r,
      height: q,
      style: { display: "block", borderBottom: `1px solid ${N}` },
      children: [
        /* @__PURE__ */ m("rect", { x: 0, y: 0, width: r, height: q, fill: X }),
        s.map((c, l) => {
          if (c.isMajor && c.time === 0) return null;
          const u = (c.time - n) * i;
          if (c.isMajor)
            return c.label ? /* @__PURE__ */ m(
              "text",
              {
                x: u,
                y: q / 2 - 2,
                fill: fe,
                fontSize: "0.75rem",
                dominantBaseline: "central",
                children: c.label
              },
              `${c.time}-${l}`
            ) : null;
          const o = Math.round(c.time / d) * d;
          if (Math.abs(c.time - o) * i < mr) return null;
          const g = q - 12;
          return /* @__PURE__ */ m("rect", { x: u, y: g, width: 1, height: 2, fill: fe }, `${c.time}-${l}`);
        })
      ]
    }
  );
}
const we = "timeline-sidebar";
function Di({ trackId: e, displayIndex: t, children: n }) {
  const r = R(null), [a, i] = ee();
  return B(() => {
    if (!r.current) return;
    const s = Io({
      element: r.current,
      getInitialData: () => ({ type: we, trackId: e, displayIndex: t })
    }), d = Ao({
      element: r.current,
      getData: () => ({ type: we, trackId: e, displayIndex: t }),
      canDrop: ({ source: c }) => c.data.type === we && c.data.trackId !== e,
      onDragEnter: ({ source: c }) => {
        i(Number(c.data.displayIndex) > t ? "top" : "bottom");
      },
      onDragLeave: () => i(void 0),
      onDrop: () => i(void 0)
    });
    return () => {
      s(), d();
    };
  }, [e, t]), /* @__PURE__ */ P("div", { ref: r, style: { position: "relative" }, children: [
    a && /* @__PURE__ */ m(
      "div",
      {
        style: {
          position: "absolute",
          left: 0,
          right: 0,
          [a === "top" ? "top" : "bottom"]: 0,
          height: 2,
          background: yn,
          zIndex: 1,
          pointerEvents: "none"
        }
      }
    ),
    n
  ] });
}
const Oi = {
  text: fi,
  image: mi,
  video: pi,
  audio: bn
};
function Ai({ track: e }) {
  const { onTrackSelect: t } = K(), n = Oi[e.type];
  return /* @__PURE__ */ P(
    J,
    {
      style: {
        height: lt,
        justifyContent: "space-between",
        cursor: "pointer",
        padding: "0 8px",
        color: be,
        borderBottom: `1px solid ${N}`,
        boxSizing: "border-box"
      },
      onMouseDown: (r) => {
        r.stopPropagation(), !e.locked && (document.activeElement instanceof HTMLElement && document.activeElement.blur(), t(e.id));
      },
      children: [
        /* @__PURE__ */ P(ie, { style: { gap: "4px" }, children: [
          /* @__PURE__ */ m(
            n,
            {
              style: { flexShrink: 0 },
              width: 16,
              height: 16,
              color: e.hidden ? fe : be
            }
          ),
          /* @__PURE__ */ m(
            J,
            {
              style: {
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: e.hidden ? fe : be
              },
              children: /* @__PURE__ */ m(jr, { text: e.name })
            }
          )
        ] }),
        /* @__PURE__ */ P(ie, { style: { gap: "2px" }, children: [
          /* @__PURE__ */ m(Ii, { track: e }),
          /* @__PURE__ */ m(Ri, { track: e }),
          /* @__PURE__ */ m(ji, { track: e })
        ] })
      ]
    }
  );
}
function Ii({ track: e }) {
  const { onTrackMuteToggle: t } = K();
  if (e.type !== "video" && e.type !== "audio") return null;
  const n = e.muted ?? !1;
  return /* @__PURE__ */ m(Sn, { onToggle: () => t(e.id, !n), muted: n, size: "medium" });
}
function Ri({ track: e }) {
  const { onTrackVisibilityToggle: t } = K();
  if (e.type === "audio") return null;
  const n = e.hidden;
  return /* @__PURE__ */ m(vi, { onToggle: () => t(e.id, !n), hidden: n });
}
function ji({ track: e }) {
  const { onTrackLockToggle: t, onTrackSelect: n, selectedTrackId: r } = K(), a = e.locked;
  return /* @__PURE__ */ m(
    Si,
    {
      onToggle: () => {
        const i = !a;
        t(e.id, i), i && r === e.id && n(null);
      },
      locked: a
    }
  );
}
function $i() {
  const e = R(null), t = R(null), n = R(null), r = C((f) => f.duration), a = C((f) => f.setContainerWidth), i = C((f) => f.tracks), { store: s, onSeek: d, onTrackSelect: c, onTrackReorder: l, selectedTrackId: u } = K();
  ai(e), ci(e), B(() => {
    const f = e.current;
    if (!f) return;
    const p = () => {
      a(f.clientWidth);
    };
    p();
    const h = new ResizeObserver(p);
    return h.observe(f), () => h.disconnect();
  }, [a]), si(t, n), B(() => Mn({
    canMonitor: ({ source: f }) => f.data.type === we,
    onDrop: ({ source: f, location: p }) => {
      const h = p.current.dropTargets[0];
      if (!h) return;
      const y = f.data.trackId, x = h.data.trackId;
      typeof y != "number" || typeof x != "number" || y !== x && l(y, x);
    }
  }), [l]), B(() => {
    const f = n.current;
    if (f)
      return ii({
        element: f,
        canScroll: ({ source: p }) => p.data.type === we
      });
  }, []);
  const o = R({
    active: !1,
    wasPlaying: !1
  }), v = O(
    (f) => {
      const p = s.getState();
      if (f.button !== 0 || p.duration === 0) return;
      o.current.active = !0, o.current.wasPlaying = p.isPlaying, document.body.style.cursor = "ew-resize", p.isPlaying && p.setPlaying(!1);
      function h(L, b = !1) {
        const w = e.current;
        if (!w) return;
        const S = s.getState(), { scrollPosition: T, duration: E, frameRate: M, tracks: I, setCurrentTime: k, setSnapIndicatorTime: D } = S, A = Z(S), F = w.getBoundingClientRect(), z = L - F.left, j = ar(z, T, A), V = Math.round(j * M) / M, ne = Math.max(0, Math.min(V, E)), pe = (b ? fn : dn) / A, Pe = Wn(I, -1, M, [0, E]), { snappedEdge: ge, snapIndicator: ae } = pt(ne, Pe, pe);
        D(ae);
        const Me = ae !== null ? ge : ne;
        k(Me), d(Me);
      }
      const y = (L) => {
        o.current.active && h(L.clientX, L.shiftKey);
      }, x = () => {
        if (!o.current.active) return;
        o.current.active = !1, document.body.style.cursor = "";
        const { setSnapIndicatorTime: L, setPlaying: b } = s.getState();
        L(null), o.current.wasPlaying && b(!0), document.removeEventListener("mousemove", y), document.removeEventListener("mouseup", x);
      };
      h(f.clientX, f.shiftKey), document.addEventListener("mousemove", y), document.addEventListener("mouseup", x);
    },
    [d, s]
  ), g = O(() => c(null), [c]);
  return /* @__PURE__ */ m(
    br,
    {
      className: "timeline-container",
      style: {
        flex: 1,
        minHeight: 0,
        background: X,
        borderTop: `1px solid ${N}`,
        fontFamily: "'DM Sans', sans-serif"
      },
      onMouseDown: g,
      children: /* @__PURE__ */ P(ie, { style: { flex: 1, minHeight: 0 }, children: [
        /* @__PURE__ */ P(
          "div",
          {
            style: {
              width: fr,
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              background: X,
              borderRight: `1px solid ${N}`
            },
            children: [
              /* @__PURE__ */ m("div", { style: { height: q, flexShrink: 0, borderBottom: `1px solid ${N}` } }),
              /* @__PURE__ */ m(
                "div",
                {
                  ref: n,
                  className: "timeline-sidebar-scroll",
                  style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: "auto",
                    borderBottom: i != null && i.length ? "none" : `1px solid ${N}`
                  },
                  children: i.map((f, p) => /* @__PURE__ */ m(Di, { trackId: f.id, displayIndex: p, children: /* @__PURE__ */ m(Ai, { track: f }) }, f.id))
                }
              ),
              r > 0 && /* @__PURE__ */ m("div", { style: { height: yt, flexShrink: 0 } })
            ]
          }
        ),
        /* @__PURE__ */ P(
          "div",
          {
            ref: e,
            style: {
              position: "relative",
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              cursor: "pointer",
              userSelect: "none"
            },
            onMouseDown: v,
            children: [
              /* @__PURE__ */ P(
                "div",
                {
                  style: {
                    position: "relative",
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column"
                  },
                  children: [
                    /* @__PURE__ */ m(Mi, {}),
                    /* @__PURE__ */ m(
                      "div",
                      {
                        ref: t,
                        className: "timeline-tracks-scroll",
                        style: {
                          flex: 1,
                          minHeight: 0,
                          overflowY: "auto"
                        },
                        children: /* @__PURE__ */ m("div", { style: { position: "relative" }, children: i.length === 0 ? /* @__PURE__ */ m(
                          "div",
                          {
                            style: {
                              position: "relative",
                              height: lt,
                              background: X,
                              borderBottom: `1px solid ${N}`,
                              boxSizing: "border-box"
                            }
                          }
                        ) : i.map((f) => /* @__PURE__ */ m(Ci, { track: f, isSelected: f.id === u }, f.id)) })
                      }
                    ),
                    /* @__PURE__ */ m(Ei, {}),
                    /* @__PURE__ */ m(Pi, {})
                  ]
                }
              ),
              r > 0 && /* @__PURE__ */ P(
                ie,
                {
                  style: {
                    height: yt,
                    flexShrink: 0,
                    borderTop: `1px solid ${N}`,
                    padding: `0 ${pn}px`
                  },
                  children: [
                    /* @__PURE__ */ m("div", { style: { width: mn, flexShrink: 0 }, children: /* @__PURE__ */ m(wi, {}) }),
                    /* @__PURE__ */ m(Ti, {})
                  ]
                }
              )
            ]
          }
        )
      ] })
    }
  );
}
export {
  lt as DEFAULT_TRACK_HEIGHT,
  Bi as PLAYBACK_CONTROLS_HEIGHT,
  Ki as PlaybackControls,
  q as RULER_HEIGHT,
  yt as SCROLLBAR_AREA_HEIGHT,
  $i as Timeline,
  Vi as TimelineProvider
};
